
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8ce8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8ce8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $acw62 = parcelRequire("acw62");
// Computer Player Interface
class $dd249245bd2d6dab$var$ComputerPlayer {
    /**
   * Makes a move for the computer player.
   * Subclasses should override this method with game-specific logic.
   * @param {Array} board - Current game board state
   * @param {number|string} player - Identifier for the current player
   * @returns {*} - Move decision; return null if no valid move exists
   */ makeMove(board, player) {
        return null;
    }
}
var $dd249245bd2d6dab$export$2e2bcd8739ae039 = $dd249245bd2d6dab$var$ComputerPlayer;



parcelRequire("acw62");
const $5d9cc854c7c12ba8$export$5e658a8851ae9322 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "20",
                y1: "20",
                x2: "80",
                y2: "80",
                stroke: "#e74c3c",
                strokeWidth: "8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "80",
                y1: "20",
                x2: "20",
                y2: "80",
                stroke: "#e74c3c",
                strokeWidth: "8",
                strokeLinecap: "round"
            })
        ]
    });
const $5d9cc854c7c12ba8$export$2af15845bcb0690 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
            cx: "50",
            cy: "50",
            r: "30",
            stroke: "#3498db",
            strokeWidth: "8",
            fill: "none"
        })
    });
const $5d9cc854c7c12ba8$export$59e20b1491f002f6 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "55",
                rx: "20",
                ry: "25",
                fill: "#8B4513"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "35",
                cy: "35",
                rx: "8",
                ry: "15",
                fill: "#8B4513"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "65",
                cy: "35",
                rx: "8",
                ry: "15",
                fill: "#8B4513"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "43",
                cy: "50",
                r: "3",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "57",
                cy: "50",
                r: "3",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "62",
                r: "4",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 50 66 Q 45 70 40 68",
                stroke: "#000",
                strokeWidth: "2",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 50 66 Q 55 70 60 68",
                stroke: "#000",
                strokeWidth: "2",
                fill: "none"
            })
        ]
    });
const $5d9cc854c7c12ba8$export$ef313b2375b0bb78 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "55",
                r: "22",
                fill: "#FF8C00"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 35 40 L 28 20 L 42 35 Z",
                fill: "#FF8C00"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 65 40 L 72 20 L 58 35 Z",
                fill: "#FF8C00"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "42",
                cy: "52",
                rx: "3",
                ry: "5",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "58",
                cy: "52",
                rx: "3",
                ry: "5",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 50 60 L 47 63 L 53 63 Z",
                fill: "#FF69B4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "30",
                y1: "55",
                x2: "40",
                y2: "54",
                stroke: "#000",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "30",
                y1: "58",
                x2: "40",
                y2: "58",
                stroke: "#000",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "70",
                y1: "55",
                x2: "60",
                y2: "54",
                stroke: "#000",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "70",
                y1: "58",
                x2: "60",
                y2: "58",
                stroke: "#000",
                strokeWidth: "1"
            })
        ]
    });
const $5d9cc854c7c12ba8$export$6d67acb5e3fd4025 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
            cx: "50",
            cy: "50",
            r: "35",
            fill: "#4CAF50"
        })
    });
const $5d9cc854c7c12ba8$export$7d4cb03a604e948a = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
            cx: "50",
            cy: "50",
            r: "35",
            fill: "#FFC107"
        })
    });
const $5d9cc854c7c12ba8$export$d6b92b1ecf852a16 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
            cx: "50",
            cy: "50",
            r: "35",
            fill: "#F44336"
        })
    });
const $5d9cc854c7c12ba8$export$630d6b95001c3ccb = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
            cx: "50",
            cy: "50",
            r: "40",
            fill: "#dc143c"
        })
    });
const $5d9cc854c7c12ba8$export$3e75b12ebae77def = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
            cx: "50",
            cy: "50",
            r: "40",
            fill: "#000080"
        })
    });
const $5d9cc854c7c12ba8$export$292502e69932201e = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "35",
                fill: "#dc143c",
                stroke: "#8b0000",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "30",
                fill: "#ff6b6b",
                opacity: "0.6"
            })
        ]
    });
const $5d9cc854c7c12ba8$export$b17398f8cd257797 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "35",
                fill: "#2c2c2c",
                stroke: "#000000",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "30",
                fill: "#555555",
                opacity: "0.6"
            })
        ]
    });
const $5d9cc854c7c12ba8$export$aeb8eb29e25d3553 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "35",
                fill: "#dc143c",
                stroke: "#8b0000",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "30",
                fill: "#ff6b6b",
                opacity: "0.6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 35 40 L 40 50 L 45 40 L 50 50 L 55 40 L 60 50 L 65 40 L 65 60 L 35 60 Z",
                fill: "#FFD700",
                stroke: "#DAA520",
                strokeWidth: "1.5"
            })
        ]
    });
const $5d9cc854c7c12ba8$export$162e8ff728aa727a = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "35",
                fill: "#2c2c2c",
                stroke: "#000000",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "30",
                fill: "#555555",
                opacity: "0.6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 35 40 L 40 50 L 45 40 L 50 50 L 55 40 L 60 50 L 65 40 L 65 60 L 35 60 Z",
                fill: "#FFD700",
                stroke: "#DAA520",
                strokeWidth: "1.5"
            })
        ]
    });
const $5d9cc854c7c12ba8$export$99f01ec413cf1a3f = ({ onPositionClick: onPositionClick, board: board, validMoves: validMoves = [] })=>{
    // Board positions (24 positions on the board)
    // Outer square: 0-7, Middle square: 8-15, Inner square: 16-23
    const positions = [
        // Outer square
        {
            x: 50,
            y: 50
        },
        {
            x: 350,
            y: 50
        },
        {
            x: 650,
            y: 50
        },
        {
            x: 650,
            y: 350
        },
        {
            x: 650,
            y: 650
        },
        {
            x: 350,
            y: 650
        },
        {
            x: 50,
            y: 650
        },
        {
            x: 50,
            y: 350
        },
        // Middle square
        {
            x: 150,
            y: 150
        },
        {
            x: 350,
            y: 150
        },
        {
            x: 550,
            y: 150
        },
        {
            x: 550,
            y: 350
        },
        {
            x: 550,
            y: 550
        },
        {
            x: 350,
            y: 550
        },
        {
            x: 150,
            y: 550
        },
        {
            x: 150,
            y: 350
        },
        // Inner square
        {
            x: 250,
            y: 250
        },
        {
            x: 350,
            y: 250
        },
        {
            x: 450,
            y: 250
        },
        {
            x: 450,
            y: 350
        },
        {
            x: 450,
            y: 450
        },
        {
            x: 350,
            y: 450
        },
        {
            x: 250,
            y: 450
        },
        {
            x: 250,
            y: 350
        } // 23 - middle left
    ];
    // Define connections (adjacency list)
    const connections = [
        [
            0,
            1
        ],
        [
            1,
            2
        ],
        [
            2,
            3
        ],
        [
            3,
            4
        ],
        [
            4,
            5
        ],
        [
            5,
            6
        ],
        [
            6,
            7
        ],
        [
            7,
            0
        ],
        [
            8,
            9
        ],
        [
            9,
            10
        ],
        [
            10,
            11
        ],
        [
            11,
            12
        ],
        [
            12,
            13
        ],
        [
            13,
            14
        ],
        [
            14,
            15
        ],
        [
            15,
            8
        ],
        [
            16,
            17
        ],
        [
            17,
            18
        ],
        [
            18,
            19
        ],
        [
            19,
            20
        ],
        [
            20,
            21
        ],
        [
            21,
            22
        ],
        [
            22,
            23
        ],
        [
            23,
            16
        ],
        [
            1,
            9
        ],
        [
            9,
            17
        ],
        [
            3,
            11
        ],
        [
            11,
            19
        ],
        [
            5,
            13
        ],
        [
            13,
            21
        ],
        [
            7,
            15
        ],
        [
            15,
            23
        ] // Left middle connections
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 700 700",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            maxWidth: '600px',
            margin: '20px auto'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "0",
                y: "0",
                width: "700",
                height: "700",
                fill: "#d4a574"
            }),
            connections.map(([from, to], idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                    x1: positions[from].x,
                    y1: positions[from].y,
                    x2: positions[to].x,
                    y2: positions[to].y,
                    stroke: "#2c1810",
                    strokeWidth: "3"
                }, idx)),
            positions.map((pos, idx)=>{
                const piece = board[idx];
                const isValidMove = validMoves.includes(idx);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                            cx: pos.x,
                            cy: pos.y,
                            r: "20",
                            fill: isValidMove ? '#90EE90' : '#f5deb3',
                            stroke: "#2c1810",
                            strokeWidth: "2",
                            style: {
                                cursor: 'pointer'
                            },
                            onClick: ()=>onPositionClick(idx)
                        }),
                        piece && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                            transform: `translate(${pos.x - 30}, ${pos.y - 30})`,
                            children: piece === 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: "30",
                                        cy: "30",
                                        r: "24",
                                        fill: "#f5f5f5",
                                        stroke: "#333",
                                        strokeWidth: "2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: "30",
                                        cy: "30",
                                        r: "20",
                                        fill: "#ffffff",
                                        opacity: "0.7"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: "30",
                                        cy: "30",
                                        r: "24",
                                        fill: "#1a1a1a",
                                        stroke: "#000",
                                        strokeWidth: "2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: "30",
                                        cy: "30",
                                        r: "20",
                                        fill: "#3a3a3a",
                                        opacity: "0.6"
                                    })
                                ]
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};


// Main TicTacToe Component
const $861b3e0b5eea3893$var$TicTacToe = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        X: 'human',
        O: 'human'
    });
    const [variant, setVariant] = (0, $acw62.useState)('traditional'); // 'traditional' or 'misere'
    const [board, setBoard] = (0, $acw62.useState)(Array(9).fill(null));
    const [isXNext, setIsXNext] = (0, $acw62.useState)(true);
    const [winner, setWinner] = (0, $acw62.useState)(null);
    const [computerPlayer] = (0, $acw62.useState)(new (0, $dd249245bd2d6dab$export$2e2bcd8739ae039)());
    // Calculate winner - supports both traditional and misère variants
    const calculateWinner = (squares)=>{
        const lines = [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                0,
                3,
                6
            ],
            [
                1,
                4,
                7
            ],
            [
                2,
                5,
                8
            ],
            [
                0,
                4,
                8
            ],
            [
                2,
                4,
                6
            ]
        ];
        for(let i = 0; i < lines.length; i++){
            const [a, b, c] = lines[i];
            if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
                // In misère variant, making three in a row means you lose
                if (variant === 'misere') // Return the opposite player (the one who didn't make three in a row wins)
                return squares[a] === 'X' ? 'O' : 'X';
                // Traditional variant: return the player who made three in a row
                return squares[a];
            }
        }
        return null;
    };
    // Handle cell click
    const handleClick = (index)=>{
        if (board[index] || winner) return;
        const newBoard = [
            ...board
        ];
        newBoard[index] = isXNext ? 'X' : 'O';
        setBoard(newBoard);
        const gameWinner = calculateWinner(newBoard);
        if (gameWinner) setWinner(gameWinner);
        setIsXNext(!isXNext);
    };
    // Reset game
    const resetGame = ()=>{
        setBoard(Array(9).fill(null));
        setIsXNext(true);
        setWinner(null);
        setGameStarted(false);
    };
    // Start game with selected player types and variant
    const startGame = ()=>{
        setGameStarted(true);
    };
    // Handle player type selection
    const handlePlayerTypeChange = (player, type)=>{
        setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    };
    // Handle computer player moves
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner || isBoardFull) return;
        const currentPlayer = isXNext ? 'X' : 'O';
        const isComputerTurn = playerTypes[currentPlayer] === 'computer';
        if (isComputerTurn) {
            // Trigger computer move after a short delay for better UX
            const timeoutId = setTimeout(()=>{
                const move = computerPlayer.makeMove(board, currentPlayer);
                if (move !== null) handleClick(move);
            }, 500);
            return ()=>clearTimeout(timeoutId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isXNext,
        gameStarted,
        winner,
        board,
        playerTypes
    ]);
    // Check if board is full (draw)
    const isBoardFull = board.every((cell)=>cell !== null);
    // Render cell content
    const renderCell = (index)=>{
        if (board[index] === 'X') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$5e658a8851ae9322), {});
        else if (board[index] === 'O') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$2af15845bcb0690), {});
        return null;
    };
    // Get game status message
    const getStatus = ()=>{
        if (winner) return `Vencedor: ${winner}`;
        else if (isBoardFull) return "Empate!";
        else return `Pr\xf3ximo Jogador: ${isXNext ? 'X' : 'O'}`;
    };
    // Show player configuration screen before game starts
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Jogo do Galo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Configura\xe7\xe3o do Jogo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "player-config",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "player-config-item",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "Variante do Jogo"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "player-type-selector",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: `player-type-button ${variant === 'traditional' ? 'selected' : ''}`,
                                    onClick: ()=>setVariant('traditional'),
                                    children: "Tradicional"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: `player-type-button ${variant === 'misere' ? 'selected' : ''}`,
                                    onClick: ()=>setVariant('misere'),
                                    children: "Mis\xe8re"
                                })
                            ]
                        }),
                        variant === 'misere' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "variant-description",
                            children: [
                                "Na variante Mis\xe8re, o jogador que fizer tr\xeas em linha ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: "perde"
                                }),
                                "!"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Configura\xe7\xe3o dos Jogadores"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador X"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.X === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('X', 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.X === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('X', 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador O"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.O === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('O', 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.O === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('O', 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Iniciar Jogo"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Jogo do Galo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "variant-label",
                children: variant === 'misere' ? "Variante Mis\xe8re" : 'Tradicional'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "game-board",
                children: board.map((cell, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "cell",
                        onClick: ()=>handleClick(index),
                        disabled: cell !== null || winner !== null,
                        children: renderCell(index)
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "Novo Jogo"
            })
        ]
    });
};
var $861b3e0b5eea3893$export$2e2bcd8739ae039 = $861b3e0b5eea3893$var$TicTacToe;




var $acw62 = parcelRequire("acw62");


// Traffic Lights Game Component
const $a55621b0d5c09ed5$var$TrafficLights = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        1: 'human',
        2: 'human'
    });
    const [board, setBoard] = (0, $acw62.useState)(Array(12).fill(null)); // 3 rows x 4 columns = 12 cells
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)(1); // Player 1 or Player 2
    const [winner, setWinner] = (0, $acw62.useState)(null);
    const [computerPlayer] = (0, $acw62.useState)(new (0, $dd249245bd2d6dab$export$2e2bcd8739ae039)());
    // Calculate winner - check for 3 in a row of the same color
    const calculateWinner = (squares, player)=>{
        const lines = [
            // Horizontal lines
            [
                0,
                1,
                2
            ],
            [
                1,
                2,
                3
            ],
            [
                4,
                5,
                6
            ],
            [
                5,
                6,
                7
            ],
            [
                8,
                9,
                10
            ],
            [
                9,
                10,
                11
            ],
            // Vertical lines
            [
                0,
                4,
                8
            ],
            [
                1,
                5,
                9
            ],
            [
                2,
                6,
                10
            ],
            [
                3,
                7,
                11
            ],
            // Diagonal lines (down-right)
            [
                0,
                5,
                10
            ],
            [
                1,
                6,
                11
            ],
            // Diagonal lines (down-left)
            [
                2,
                5,
                8
            ],
            [
                3,
                6,
                9
            ]
        ];
        for (const [a, b, c] of lines){
            if (squares[a] && squares[b] && squares[c] && squares[a].color === squares[b].color && squares[a].color === squares[c].color) return {
                player: player,
                color: squares[a].color
            };
        }
        return null;
    };
    // Handle cell click with automatic color progression
    const handleClick = (index)=>{
        if (winner) return;
        const cell = board[index];
        let nextColor;
        // Determine next color based on current cell state
        if (cell === null) // Empty cell -> place green
        nextColor = 'green';
        else if (cell.color === 'green') // Green -> change to yellow
        nextColor = 'yellow';
        else if (cell.color === 'yellow') // Yellow -> change to red
        nextColor = 'red';
        else // Red -> cannot be clicked (no further progression)
        return;
        // Update board with new piece
        const newBoard = [
            ...board
        ];
        newBoard[index] = {
            player: currentPlayer,
            color: nextColor
        };
        setBoard(newBoard);
        // Check for winner
        const gameWinner = calculateWinner(newBoard, currentPlayer);
        if (gameWinner) setWinner(gameWinner);
        else // Automatically switch to next player
        setCurrentPlayer(currentPlayer === 1 ? 2 : 1);
    };
    // Reset game
    const resetGame = ()=>{
        setBoard(Array(12).fill(null));
        setCurrentPlayer(1);
        setWinner(null);
        setGameStarted(false);
    };
    // Start game with selected player types
    const startGame = ()=>{
        setGameStarted(true);
    };
    // Handle player type selection
    const handlePlayerTypeChange = (player, type)=>{
        setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    };
    // Handle computer player moves
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner) return;
        const isComputerTurn = playerTypes[currentPlayer] === 'computer';
        if (isComputerTurn) {
            // Trigger computer move after a short delay for better UX
            const timeoutId = setTimeout(()=>{
                const move = computerPlayer.makeMove(board, currentPlayer);
                move;
            }, 500);
            return ()=>clearTimeout(timeoutId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPlayer,
        gameStarted,
        winner,
        board,
        playerTypes
    ]);
    // Render cell content
    const renderCell = (index)=>{
        const cell = board[index];
        if (!cell) return null;
        if (cell.color === 'green') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$6d67acb5e3fd4025), {});
        else if (cell.color === 'yellow') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$7d4cb03a604e948a), {});
        else if (cell.color === 'red') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$d6b92b1ecf852a16), {});
        return null;
    };
    // Get game status message
    const getStatus = ()=>{
        if (winner) return `Vencedor: Jogador ${winner.player}`;
        else return `Turno do Jogador ${currentPlayer}`;
    };
    // Show player configuration screen before game starts
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Sem\xe1foro"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Configura\xe7\xe3o dos Jogadores"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador 1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador 2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Iniciar Jogo"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Sem\xe1foro"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "game-board traffic-lights-board",
                children: board.map((cell, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "cell",
                        onClick: ()=>handleClick(index),
                        disabled: winner !== null,
                        children: renderCell(index)
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "game-buttons",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "new-game-button",
                    onClick: resetGame,
                    children: "Novo Jogo"
                })
            })
        ]
    });
};
var $a55621b0d5c09ed5$export$2e2bcd8739ae039 = $a55621b0d5c09ed5$var$TrafficLights;




var $acw62 = parcelRequire("acw62");

// The four central cells of the 8×8 board (rows 3–4, cols 3–4)
const $e5929160de509978$var$CENTRAL_CELLS = new Set([
    27,
    28,
    35,
    36
]);
/**
 * Returns the orthogonally adjacent cell indices within the 8×8 board.
 * @param {number} index - Cell index (0–63)
 * @returns {number[]}
 */ const $e5929160de509978$var$getAdjacentCells = (index)=>{
    const row = Math.floor(index / 8);
    const col = index % 8;
    const adjacent = [];
    if (row > 0) adjacent.push(index - 8);
    if (row < 7) adjacent.push(index + 8);
    if (col > 0) adjacent.push(index - 1);
    if (col < 7) adjacent.push(index + 1);
    return adjacent;
};
/**
 * Smart computer player for the Cats and Dogs game.
 * Extends the generic ComputerPlayer interface with game-specific logic.
 */ class $e5929160de509978$var$CatsAndDogsComputerPlayer extends (0, $dd249245bd2d6dab$export$2e2bcd8739ae039) {
    /**
	 * Returns true if the given player has not yet placed any piece on the board.
	 * @param {Array} board
	 * @param {number} player - 1 (cats) or 2 (dogs)
	 * @returns {boolean}
	 */ isFirstMove(board, player) {
        const piece = player === 1 ? 'cat' : 'dog';
        return !board.some((cell)=>cell === piece);
    }
    /**
	 * Checks whether placing at `index` is a valid move for `player`.
	 * @param {number} index
	 * @param {number} player
	 * @param {Array} board
	 * @returns {boolean}
	 */ isValidMoveFor(index, player, board) {
        if (board[index] !== null) return false;
        if (this.isFirstMove(board, player)) {
            if (player === 1 && !$e5929160de509978$var$CENTRAL_CELLS.has(index)) return false;
            if (player === 2 && $e5929160de509978$var$CENTRAL_CELLS.has(index)) return false;
        }
        const opponentPiece = player === 1 ? 'dog' : 'cat';
        for (const adj of $e5929160de509978$var$getAdjacentCells(index)){
            if (board[adj] === opponentPiece) return false;
        }
        return true;
    }
    /**
	 * Returns all valid move indices for a player.
	 * @param {number} player
	 * @param {Array} board
	 * @returns {number[]}
	 */ getAllValidMoves(player, board) {
        const moves = [];
        for(let i = 0; i < 64; i++)if (this.isValidMoveFor(i, player, board)) moves.push(i);
        return moves;
    }
    /**
	 * Counts empty cells that are permanently guaranteed to the player on the given
	 * board — i.e. cells adjacent only to the player's own pieces and which the
	 * opponent can never reach to destroy.
	 * @param {number} player
	 * @param {Array} board
	 * @returns {number}
	 */ countGuaranteedCells(player, board) {
        const myPiece = player === 1 ? 'cat' : 'dog';
        const oppPiece = player === 1 ? 'dog' : 'cat';
        let count = 0;
        for(let i = 0; i < 64; i++){
            if (board[i] !== null) continue;
            const adj = $e5929160de509978$var$getAdjacentCells(i);
            const hasMyPiece = adj.some((j)=>board[j] === myPiece);
            const hasOppPiece = adj.some((j)=>board[j] === oppPiece);
            if (!hasMyPiece || hasOppPiece) continue;
            // Permanently guaranteed only if the opponent can never place an adjacent
            // piece to "destroy" this cell (i.e. every empty neighbor already has a
            // neighbor of mine, blocking the opponent from landing there).
            const canOppDestroy = adj.some((j)=>board[j] === null && !$e5929160de509978$var$getAdjacentCells(j).some((k)=>board[k] === myPiece));
            if (!canOppDestroy) count++;
        }
        return count;
    }
    /**
	 * Returns a composite heuristic score for placing at `index`.
	 * Higher scores are better.
	 * @param {number} index
	 * @param {number} player
	 * @param {Array} board
	 * @returns {number}
	 */ scoreMove(index, player, board) {
        const opponent = player === 1 ? 2 : 1;
        const myPiece = player === 1 ? 'cat' : 'dog';
        const newBoard = [
            ...board
        ];
        newBoard[index] = myPiece;
        let score = 0;
        // a. Maximize guaranteed (permanently owned) cells
        const guaranteedBefore = this.countGuaranteedCells(player, board);
        const guaranteedAfter = this.countGuaranteedCells(player, newBoard);
        score += (guaranteedAfter - guaranteedBefore) * 10;
        // b. Territory expansion: new empty cells adjacent to the placed piece
        const newAdjacencies = $e5929160de509978$var$getAdjacentCells(index).filter((j)=>newBoard[j] === null).length;
        score += newAdjacencies * 3;
        // c. Deny opponent expansion: reduce their valid-move count
        const oppMovesBefore = this.getAllValidMoves(opponent, board).length;
        const oppMovesAfter = this.getAllValidMoves(opponent, newBoard).length;
        score += (oppMovesBefore - oppMovesAfter) * 5;
        // d. Avoid placing on already-guaranteed cells (save them for auto-fill)
        // If `index` is itself already permanently guaranteed before this move,
        // the cell would be auto-filled later anyway — prefer expanding elsewhere.
        const adjOfIndex = $e5929160de509978$var$getAdjacentCells(index);
        const oppPiece = player === 1 ? 'dog' : 'cat';
        const indexAlreadyGuaranteed = adjOfIndex.some((j)=>board[j] === myPiece) && !adjOfIndex.some((j)=>board[j] === oppPiece) && !adjOfIndex.some((j)=>board[j] === null && !$e5929160de509978$var$getAdjacentCells(j).some((k)=>board[k] === myPiece));
        if (indexAlreadyGuaranteed) score -= 5;
        // e. Central positioning bonus during the early game
        const pieceCount = board.filter((c)=>c !== null).length;
        if (pieceCount < 12) {
            const row = Math.floor(index / 8);
            const col = index % 8;
            const centerDist = Math.abs(row - 3.5) + Math.abs(col - 3.5);
            score += Math.max(0, 5 - centerDist);
        }
        return score;
    }
    /**
	 * Makes a move for the computer player.
	 * @param {Array} board - 64-element array (null | 'cat' | 'dog')
	 * @param {number} player - 1 (cats) or 2 (dogs)
	 * @returns {number|null} - Valid cell index, or null if no move exists
	 */ makeMove(board, player) {
        const validMoves = this.getAllValidMoves(player, board);
        if (validMoves.length === 0) return null;
        if (validMoves.length === 1) return validMoves[0];
        const opponent = player === 1 ? 2 : 1;
        const myPiece = player === 1 ? 'cat' : 'dog';
        const oppPiece = opponent === 1 ? 'cat' : 'dog';
        // 1. Immediate win: any move that leaves the opponent with zero valid moves
        for (const move of validMoves){
            const newBoard = [
                ...board
            ];
            newBoard[move] = myPiece;
            if (this.getAllValidMoves(opponent, newBoard).length === 0) return move;
        }
        // 2. Avoid losing moves: filter out moves that hand the opponent an instant win
        const safeMoves = validMoves.filter((move)=>{
            const newBoard = [
                ...board
            ];
            newBoard[move] = myPiece;
            const opponentMoves = this.getAllValidMoves(opponent, newBoard);
            return !opponentMoves.some((oppMove)=>{
                const afterOppBoard = [
                    ...newBoard
                ];
                afterOppBoard[oppMove] = oppPiece;
                return this.getAllValidMoves(player, afterOppBoard).length === 0;
            });
        });
        const candidates = safeMoves.length > 0 ? safeMoves : validMoves;
        // 3. Score each candidate and pick the best
        const scored = candidates.map((move)=>({
                move: move,
                score: this.scoreMove(move, player, board)
            }));
        const maxScore = Math.max(...scored.map((s)=>s.score));
        const best = scored.filter((s)=>s.score === maxScore);
        // 4. Fallback: random choice among equally-scored moves
        return best[Math.floor(Math.random() * best.length)].move;
    }
}
var $e5929160de509978$export$2e2bcd8739ae039 = $e5929160de509978$var$CatsAndDogsComputerPlayer;


// Inline SVG content for Cat (no wrapping <svg>, so it can be placed inside a nested SVG)
const $ef100ffa4f625ae1$var$CatContent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 18 44 Q 16 6 44 32 Z",
                fill: "#FF8C00"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 82 44 Q 84 6 56 32 Z",
                fill: "#FF8C00"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 23 42 Q 22 14 42 32 Z",
                fill: "#ffb347"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 77 42 Q 78 14 58 32 Z",
                fill: "#ffb347"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "60",
                r: "38",
                fill: "#FF8C00"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "36",
                cy: "54",
                r: "8",
                fill: "#2d1200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "64",
                cy: "54",
                r: "8",
                fill: "#2d1200"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "38",
                cy: "52",
                r: "3",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "66",
                cy: "52",
                r: "3",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 50 65 L 45 71 L 55 71 Z",
                fill: "#FF69B4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 43 74 Q 50 80 57 74",
                stroke: "#cc6600",
                strokeWidth: "2",
                fill: "none",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "63",
                x2: "36",
                y2: "65",
                stroke: "#cc6600",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "70",
                x2: "36",
                y2: "70",
                stroke: "#cc6600",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "96",
                y1: "63",
                x2: "64",
                y2: "65",
                stroke: "#cc6600",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "96",
                y1: "70",
                x2: "64",
                y2: "70",
                stroke: "#cc6600",
                strokeWidth: "1.5"
            })
        ]
    });
// Inline SVG content for Dog
const $ef100ffa4f625ae1$var$DogContent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "14",
                cy: "56",
                rx: "15",
                ry: "24",
                fill: "#a0724a"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "86",
                cy: "56",
                rx: "15",
                ry: "24",
                fill: "#a0724a"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "38",
                fill: "#c8855a"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "68",
                rx: "20",
                ry: "14",
                fill: "#a0724a"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "37",
                cy: "44",
                r: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "63",
                cy: "44",
                r: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "38",
                cy: "45",
                r: "5",
                fill: "#1a0800"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "64",
                cy: "45",
                r: "5",
                fill: "#1a0800"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "40",
                cy: "43",
                r: "2",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "66",
                cy: "43",
                r: "2",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "63",
                rx: "9",
                ry: "6",
                fill: "#1a0800"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "47",
                cy: "61",
                rx: "3.5",
                ry: "1.8",
                fill: "#5a2a10",
                opacity: "0.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "50",
                y1: "69",
                x2: "50",
                y2: "74",
                stroke: "#1a0800",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 50 74 Q 42 79 37 77",
                stroke: "#1a0800",
                strokeWidth: "2",
                fill: "none",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 50 74 Q 58 79 63 77",
                stroke: "#1a0800",
                strokeWidth: "2",
                fill: "none",
                strokeLinecap: "round"
            })
        ]
    });
// The four central cells of the 8×8 board (rows 3–4, cols 3–4)
const $ef100ffa4f625ae1$var$CENTRAL_CELLS = new Set([
    27,
    28,
    35,
    36
]);
// Module-level pure helper – no state dependency
const $ef100ffa4f625ae1$var$getAdjacentCells = (index)=>{
    const row = Math.floor(index / 8);
    const col = index % 8;
    const adjacent = [];
    if (row > 0) adjacent.push(index - 8);
    if (row < 7) adjacent.push(index + 8);
    if (col > 0) adjacent.push(index - 1);
    if (col < 7) adjacent.push(index + 1);
    return adjacent;
};
/**
 * Returns true when every empty cell is either destroyed (both-side neighbour)
 * or permanently owned by one player – meaning the rest of the game is
 * fully determined and can be auto-filled.
 */ const $ef100ffa4f625ae1$var$isAutoFillTriggered = (currentBoard)=>{
    for(let i = 0; i < 64; i++){
        if (currentBoard[i] !== null) continue;
        const adj = $ef100ffa4f625ae1$var$getAdjacentCells(i);
        const hasCat = adj.some((j)=>currentBoard[j] === 'cat');
        const hasDog = adj.some((j)=>currentBoard[j] === 'dog');
        if (hasCat && hasDog) continue; // destroyed – fine
        if (hasDog) {
            const canCatDestroy = adj.some((j)=>currentBoard[j] === null && !$ef100ffa4f625ae1$var$getAdjacentCells(j).some((k)=>currentBoard[k] === 'dog'));
            if (canCatDestroy) return false; // only temporarily dog-owned
            continue; // permanently dog-owned – fine
        }
        if (hasCat) {
            const canDogDestroy = adj.some((j)=>currentBoard[j] === null && !$ef100ffa4f625ae1$var$getAdjacentCells(j).some((k)=>currentBoard[k] === 'cat'));
            if (canDogDestroy) return false; // only temporarily cat-owned
            continue; // permanently cat-owned – fine
        }
        return false; // neutral cell – game not resolved yet
    }
    return true;
};
/**
 * Builds an ordered fill queue for the auto-fill phase.
 * Returns { queue: [{index, piece}], winner } where winner is the player
 * whose opponent runs out of cells to play first.
 */ const $ef100ffa4f625ae1$var$buildAutoFillQueue = (currentBoard, startingPlayer)=>{
    const catCells = [];
    const dogCells = [];
    for(let i = 0; i < 64; i++){
        if (currentBoard[i] !== null) continue;
        const adj = $ef100ffa4f625ae1$var$getAdjacentCells(i);
        const hasCat = adj.some((j)=>currentBoard[j] === 'cat');
        const hasDog = adj.some((j)=>currentBoard[j] === 'dog');
        if (hasDog && !hasCat) {
            const canCatDestroy = adj.some((j)=>currentBoard[j] === null && !$ef100ffa4f625ae1$var$getAdjacentCells(j).some((k)=>currentBoard[k] === 'dog'));
            if (!canCatDestroy) dogCells.push(i);
        } else if (hasCat && !hasDog) {
            const canDogDestroy = adj.some((j)=>currentBoard[j] === null && !$ef100ffa4f625ae1$var$getAdjacentCells(j).some((k)=>currentBoard[k] === 'cat'));
            if (!canDogDestroy) catCells.push(i);
        }
    }
    const queue = [];
    let catIdx = 0, dogIdx = 0;
    let player = startingPlayer;
    while(catIdx < catCells.length || dogIdx < dogCells.length){
        if (player === 1) {
            if (catIdx < catCells.length) queue.push({
                index: catCells[catIdx++],
                piece: 'cat'
            });
            else return {
                queue: queue,
                winner: 2
            }; // cats have no cell to play → dogs win
        } else {
            if (dogIdx < dogCells.length) queue.push({
                index: dogCells[dogIdx++],
                piece: 'dog'
            });
            else return {
                queue: queue,
                winner: 1
            }; // dogs have no cell to play → cats win
        }
        player = player === 1 ? 2 : 1;
    }
    // Both ran out; the next player to move has nothing → they lose
    return {
        queue: queue,
        winner: player === 1 ? 2 : 1
    };
};
// Cats and Dogs Game Component
/**
 * CatsAndDogs: A strategic two-player board game on an 8x8 grid
 * 
 * Game Rules:
 * - Players alternate placing their pieces (one player uses cats, the other uses dogs)
 * - Dogs and cats CANNOT be placed orthogonally adjacent to each other (diagonal is allowed)
 * - On their FIRST move, cats must place in one of the 4 central cells;
 *   dogs must place OUTSIDE the 4 central cells
 * - A player loses if they cannot make a valid move on their turn
 * - The game ends when no valid moves are available for the current player
 */ const $ef100ffa4f625ae1$var$CatsAndDogs = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        1: 'human',
        2: 'human'
    });
    const [board, setBoard] = (0, $acw62.useState)(Array(64).fill(null)); // 8x8 = 64 cells
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)(1); // Player 1 (cats) or Player 2 (dogs)
    const [winner, setWinner] = (0, $acw62.useState)(null);
    const [firstMoveDone, setFirstMoveDone] = (0, $acw62.useState)({
        1: false,
        2: false
    });
    const [autoFillQueue, setAutoFillQueue] = (0, $acw62.useState)([]);
    const [computerPlayer] = (0, $acw62.useState)(new (0, $e5929160de509978$export$2e2bcd8739ae039)());
    const pendingWinnerRef = (0, $acw62.useRef)(null);
    /**
	 * Check if placing a piece at the given index is a valid move
	 * @param {number} index - The cell index to check
	 * @param {number} player - The player making the move (1 or 2)
	 * @param {Array} currentBoard - The current board state
	 * @returns {boolean} - True if the move is valid
	 */ const isValidMove = (index, player, currentBoard)=>{
        // Cell must be empty
        if (currentBoard[index] !== null) return false;
        // First-move placement restriction
        if (!firstMoveDone[player]) {
            if (player === 1 && !$ef100ffa4f625ae1$var$CENTRAL_CELLS.has(index)) return false; // cats: central only
            if (player === 2 && $ef100ffa4f625ae1$var$CENTRAL_CELLS.has(index)) return false; // dogs: outside central only
        }
        // Check all orthogonally adjacent cells
        const adjacentCells = $ef100ffa4f625ae1$var$getAdjacentCells(index);
        const opponentPiece = player === 1 ? 'dog' : 'cat';
        for (const adjIndex of adjacentCells){
            if (currentBoard[adjIndex] === opponentPiece) return false; // Cannot place next to opponent's piece
        }
        return true;
    };
    /**
	 * Check if the current player has any valid moves available
	 * @param {number} player - The player to check
	 * @param {Array} currentBoard - The current board state
	 * @returns {boolean} - True if at least one valid move exists
	 */ const hasValidMoves = (player, currentBoard)=>{
        for(let i = 0; i < 64; i++){
            if (isValidMove(i, player, currentBoard)) return true;
        }
        return false;
    };
    /**
	 * Determine the background fill colour for a cell.
	 * Occupied cells keep their piece tint.
	 * Empty cells are classified by their orthogonal neighbours:
	 *   - both cat AND dog neighbours  → light red   ("destroyed": neither player can place)
	 *   - only dog neighbour(s)        → light blue  ("belongs to dogs": only dogs can place)
	 *   - only cat neighbour(s)        → light orange ("belongs to cats": only cats can place)
	 *   - no piece neighbours          → neutral gray
	 */ const getCellFill = (index, currentBoard)=>{
        const cell = currentBoard[index];
        if (cell === 'cat') return '#fff3e0';
        if (cell === 'dog') return '#e3f2fd';
        const adjacent = $ef100ffa4f625ae1$var$getAdjacentCells(index);
        const hasCatNeighbor = adjacent.some((i)=>currentBoard[i] === 'cat');
        const hasDogNeighbor = adjacent.some((i)=>currentBoard[i] === 'dog');
        if (hasCatNeighbor && hasDogNeighbor) return '#ffcccc'; // destroyed – light red
        if (hasDogNeighbor) {
            // Permanently dog-owned if no empty neighbour is free of dog-neighbours
            // (i.e. a cat can never legally land on any neighbour to destroy this cell)
            const canCatEverDestroy = adjacent.some((i)=>currentBoard[i] === null && !$ef100ffa4f625ae1$var$getAdjacentCells(i).some((j)=>currentBoard[j] === 'dog'));
            return canCatEverDestroy ? '#cce8ff' : '#5a9fd4'; // light vs dark blue
        }
        if (hasCatNeighbor) {
            // Permanently cat-owned if no empty neighbour is free of cat-neighbours
            const canDogEverDestroy = adjacent.some((i)=>currentBoard[i] === null && !$ef100ffa4f625ae1$var$getAdjacentCells(i).some((j)=>currentBoard[j] === 'cat'));
            return canDogEverDestroy ? '#ffe5cc' : '#e07a20'; // light vs dark orange
        }
        return '#f0f0f0'; // neutral
    };
    /**
	 * Handle cell click - attempt to place a piece
	 * @param {number} index - The cell index clicked
	 */ const handleClick = (index)=>{
        if (winner) return;
        // Check if move is valid
        if (!isValidMove(index, currentPlayer, board)) return;
        // Place the piece
        const newBoard = [
            ...board
        ];
        newBoard[index] = currentPlayer === 1 ? 'cat' : 'dog';
        setBoard(newBoard);
        // Mark first move as done for this player
        if (!firstMoveDone[currentPlayer]) setFirstMoveDone((prev)=>({
                ...prev,
                [currentPlayer]: true
            }));
        // Switch to next player
        const nextPlayer = currentPlayer === 1 ? 2 : 1;
        // Check if next player has any valid moves
        if (!hasValidMoves(nextPlayer, newBoard)) // Current player wins because opponent has no valid moves
        setWinner(currentPlayer);
        else if ($ef100ffa4f625ae1$var$isAutoFillTriggered(newBoard)) {
            // All remaining empty cells are permanently resolved – auto-fill them
            const { queue: queue, winner: autoWinner } = $ef100ffa4f625ae1$var$buildAutoFillQueue(newBoard, nextPlayer);
            if (queue.length === 0) setWinner(autoWinner);
            else {
                pendingWinnerRef.current = autoWinner;
                setAutoFillQueue(queue);
            }
        } else setCurrentPlayer(nextPlayer);
    };
    /**
	 * Reset the game to initial state
	 */ const resetGame = ()=>{
        setBoard(Array(64).fill(null));
        setCurrentPlayer(1);
        setWinner(null);
        setFirstMoveDone({
            1: false,
            2: false
        });
        setAutoFillQueue([]);
        pendingWinnerRef.current = null;
        setGameStarted(false);
    };
    /**
	 * Start the game with selected player types
	 */ const startGame = ()=>{
        setGameStarted(true);
    };
    /**
	 * Handle player type selection
	 */ const handlePlayerTypeChange = (player, type)=>{
        setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    };
    // Step through the auto-fill queue one cell at a time with a short delay
    (0, $acw62.useEffect)(()=>{
        if (autoFillQueue.length === 0) return;
        const [next, ...rest] = autoFillQueue;
        const timeoutId = setTimeout(()=>{
            setBoard((prev)=>{
                const nb = [
                    ...prev
                ];
                nb[next.index] = next.piece;
                return nb;
            });
            setAutoFillQueue(rest);
            if (rest.length === 0) setWinner(pendingWinnerRef.current);
        }, 150);
        return ()=>clearTimeout(timeoutId);
    }, [
        autoFillQueue
    ]);
    // Handle computer player moves
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner || autoFillQueue.length > 0) return;
        const isComputerTurn = playerTypes[currentPlayer] === 'computer';
        if (isComputerTurn) {
            // Trigger computer move after a short delay for better UX
            const timeoutId = setTimeout(()=>{
                const move = computerPlayer.makeMove(board, currentPlayer);
                if (move !== null) handleClick(move);
            }, 500);
            return ()=>clearTimeout(timeoutId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPlayer,
        gameStarted,
        winner,
        board,
        playerTypes,
        autoFillQueue
    ]);
    /**
	 * Get the current game status message
	 * @returns {string} - Status message
	 */ const getStatus = ()=>{
        if (winner) {
            const winnerName = winner === 1 ? 'Gatos' : "C\xe3es";
            return `Vencedor: ${winnerName}!`;
        } else {
            const currentPiece = currentPlayer === 1 ? 'Gatos' : "C\xe3es";
            return `Turno Atual: ${currentPiece}`;
        }
    };
    // Show player configuration screen before game starts
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Gatos e C\xe3es"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Configura\xe7\xe3o dos Jogadores"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador 1 (Gatos)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador 2 (C\xe3es)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Iniciar Jogo"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Gatos e C\xe3es"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: "0 0 800 800",
                className: "cats-and-dogs-svg",
                children: board.map((cell, index)=>{
                    const row = Math.floor(index / 8);
                    const col = index % 8;
                    const x = col * 100;
                    const y = row * 100;
                    const isHumanTurn = playerTypes[currentPlayer] === 'human';
                    const isValid = !winner && isHumanTurn && isValidMove(index, currentPlayer, board);
                    const isDisabled = !!winner || !isHumanTurn;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        onClick: ()=>!isDisabled && handleClick(index),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: x + 2,
                                y: y + 2,
                                width: 96,
                                height: 96,
                                rx: 8,
                                fill: getCellFill(index, board),
                                stroke: isValid ? '#a0aec0' : '#ddd',
                                strokeWidth: isValid ? 2 : 1,
                                style: {
                                    cursor: isValid ? 'pointer' : 'default'
                                }
                            }),
                            cell && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                x: x + 4,
                                y: y + 4,
                                width: 92,
                                height: 92,
                                viewBox: "0 0 100 100",
                                children: cell === 'cat' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef100ffa4f625ae1$var$CatContent, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef100ffa4f625ae1$var$DogContent, {})
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "Novo Jogo"
            })
        ]
    });
};
var $ef100ffa4f625ae1$export$2e2bcd8739ae039 = $ef100ffa4f625ae1$var$CatsAndDogs;




var $acw62 = parcelRequire("acw62");

// Hex Game Component
/**
 * Hex: A two-player strategy game on an 11x11 hexagonal grid
 * 
 * Game Rules:
 * - Players alternate placing pieces (Player 1: red, Player 2: blue)
 * - Red player connects top-left to bottom-right edges
 * - Blue player connects top-right to bottom-left edges (left to right on the slanted board)
 * - First player to create a connected path wins
 */ const $3b6981476d25eccc$var$Hex = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        1: 'human',
        2: 'human'
    });
    const [board, setBoard] = (0, $acw62.useState)(Array(121).fill(null)); // 11x11 = 121 cells
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)(1); // Player 1 (red) or Player 2 (blue)
    const [winner, setWinner] = (0, $acw62.useState)(null);
    const [computerPlayer] = (0, $acw62.useState)(new (0, $dd249245bd2d6dab$export$2e2bcd8739ae039)());
    const [hoveredCell, setHoveredCell] = (0, $acw62.useState)(null);
    /**
   * Convert row and column to board index
   * @param {number} row - Row number (0-10)
   * @param {number} col - Column number (0-10)
   * @returns {number} - Board index
   */ const coordsToIndex = (row, col)=>{
        return row * 11 + col;
    };
    /**
   * Convert board index to row and column
   * @param {number} index - Board index
   * @returns {Object} - {row, col}
   */ const indexToCoords = (index)=>{
        return {
            row: Math.floor(index / 11),
            col: index % 11
        };
    };
    /**
   * Get the neighbors of a hex cell in the slanted grid
   * In a hex grid, each cell has up to 6 neighbors
   * For this slanted layout where each row shifts right:
   * - Same row: left (col-1) and right (col+1)
   * - Row above: same col and col+1
   * - Row below: col-1 and same col
   * @param {number} row - Row number
   * @param {number} col - Column number
   * @returns {Array<number>} - Array of neighbor indices
   */ const getHexNeighbors = (row, col)=>{
        const neighbors = [];
        // Left (same row)
        if (col > 0) neighbors.push(coordsToIndex(row, col - 1));
        // Right (same row)
        if (col < 10) neighbors.push(coordsToIndex(row, col + 1));
        // Top-left (row above, same column)
        if (row > 0) neighbors.push(coordsToIndex(row - 1, col));
        // Top-right (row above, column + 1)
        if (row > 0 && col < 10) neighbors.push(coordsToIndex(row - 1, col + 1));
        // Bottom-left (row below, column - 1)
        if (row < 10 && col > 0) neighbors.push(coordsToIndex(row + 1, col - 1));
        // Bottom-right (row below, same column)
        if (row < 10) neighbors.push(coordsToIndex(row + 1, col));
        return neighbors;
    };
    /**
   * Check if a player has won by creating a connected path
   * For red (player 1): connect top edge (row 0) to bottom edge (row 10)
   * For blue (player 2): connect left edge (col 0) to right edge (col 10)
   * @param {Array} currentBoard - The current board state
   * @param {number} player - The player to check (1 or 2)
   * @returns {boolean} - True if the player has won
   */ const checkWin = (currentBoard, player)=>{
        const piece = player === 1 ? 'red' : 'blue';
        const visited = new Set();
        const queue = [];
        // Initialize starting positions based on player
        if (player === 1) // Red player: start from top edge (row 0)
        for(let col = 0; col < 11; col++){
            const idx = coordsToIndex(0, col);
            if (currentBoard[idx] === piece) {
                queue.push(idx);
                visited.add(idx);
            }
        }
        else // Blue player: start from left edge (col 0)
        for(let row = 0; row < 11; row++){
            const idx = coordsToIndex(row, 0);
            if (currentBoard[idx] === piece) {
                queue.push(idx);
                visited.add(idx);
            }
        }
        // BFS to find connected path
        while(queue.length > 0){
            const current = queue.shift();
            const { row: row, col: col } = indexToCoords(current);
            // Check if we've reached the goal edge
            if (player === 1 && row === 10) return true; // Red reached bottom edge
            if (player === 2 && col === 10) return true; // Blue reached right edge
            // Explore neighbors
            const neighbors = getHexNeighbors(row, col);
            for (const neighbor of neighbors)if (!visited.has(neighbor) && currentBoard[neighbor] === piece) {
                visited.add(neighbor);
                queue.push(neighbor);
            }
        }
        return false;
    };
    /**
   * Handle cell click - attempt to place a piece
   * @param {number} row - Row of clicked cell
   * @param {number} col - Column of clicked cell
   */ const handleClick = (0, $acw62.useCallback)((row, col)=>{
        const index = coordsToIndex(row, col);
        if (winner || board[index] !== null) return;
        // Place the piece
        const newBoard = [
            ...board
        ];
        newBoard[index] = currentPlayer === 1 ? 'red' : 'blue';
        setBoard(newBoard);
        // Check if current player has won
        if (checkWin(newBoard, currentPlayer)) setWinner(currentPlayer);
        else // Switch to next player
        setCurrentPlayer(currentPlayer === 1 ? 2 : 1);
    }, [
        board,
        currentPlayer,
        winner
    ]);
    /**
   * Reset the game to initial state
   */ const resetGame = ()=>{
        setBoard(Array(121).fill(null));
        setCurrentPlayer(1);
        setWinner(null);
        setGameStarted(false);
    };
    /**
   * Start the game with selected player types
   */ const startGame = ()=>{
        setGameStarted(true);
    };
    /**
   * Handle player type selection
   */ const handlePlayerTypeChange = (player, type)=>{
        setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    };
    // Handle computer player moves
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner) return;
        const isComputerTurn = playerTypes[currentPlayer] === 'computer';
        if (isComputerTurn) {
            // Trigger computer move after a short delay for better UX
            const timeoutId = setTimeout(()=>{
                const move = computerPlayer.makeMove(board, currentPlayer);
                if (move !== null) {
                    const { row: row, col: col } = indexToCoords(move);
                    handleClick(row, col);
                }
            }, 500);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        currentPlayer,
        gameStarted,
        winner,
        board,
        playerTypes,
        computerPlayer,
        handleClick
    ]);
    /**
   * Get the current game status message
   * @returns {string} - Status message
   */ const getStatus = ()=>{
        if (winner) {
            const winnerName = winner === 1 ? 'Red' : 'Blue';
            return `Winner: ${winnerName}!`;
        } else {
            const currentColor = currentPlayer === 1 ? 'Red' : 'Blue';
            return `Current Turn: ${currentColor}`;
        }
    };
    /**
   * Handle SVG cell click by extracting row and col from data attributes
   */ const handleSVGClick = (event)=>{
        const target = event.target;
        if (target.tagName === 'polygon' && target.hasAttribute('data-row')) {
            const row = parseInt(target.getAttribute('data-row'), 10);
            const col = parseInt(target.getAttribute('data-col'), 10);
            handleClick(row, col);
        }
    };
    /**
   * Handle mouse over for hover effects
   */ const handleSVGMouseOver = (event)=>{
        const target = event.target;
        if (target.tagName === 'polygon' && target.hasAttribute('data-row')) {
            const row = parseInt(target.getAttribute('data-row'), 10);
            const col = parseInt(target.getAttribute('data-col'), 10);
            const index = coordsToIndex(row, col);
            if (!winner && board[index] === null) setHoveredCell(index);
        }
    };
    /**
   * Handle mouse out to clear hover effects
   */ const handleSVGMouseOut = ()=>{
        setHoveredCell(null);
    };
    /**
   * Render the hex board with pieces
   */ const renderBoard = ()=>{
        const SIZE = 11;
        const R = 30; // circumradius (centre → vertex)
        const GAP = 2; // gap between cells
        const CELL_R = R - GAP; // drawn hexagon radius
        const BORDER_W = 8; // coloured border strip width
        const W_HEX = Math.sqrt(3) * R; // horizontal cell spacing
        const V_STEP = 1.5 * R; // vertical row spacing
        const PAD = 15;
        const RED_COLOR = '#dc143c';
        const BLUE_COLOR = '#1a5fb4';
        // Pointy-top hex vertex at position k (0 = top, clockwise)
        const hexVertex = (cx, cy, r, k)=>{
            const a = Math.PI / 3 * k - Math.PI / 2;
            return {
                x: cx + r * Math.cos(a),
                y: cy + r * Math.sin(a)
            };
        };
        // Polygon points string for a full hexagon
        const hexPoints = (cx, cy, r)=>Array.from({
                length: 6
            }, (_, k)=>{
                const v = hexVertex(cx, cy, r, k);
                return `${v.x},${v.y}`;
            }).join(' ');
        // Cell centre for (row, col) in the parallelogram layout
        const cellCx = (row, col)=>PAD + BORDER_W + R + col * W_HEX + row * W_HEX * 0.5;
        const cellCy = (row)=>PAD + BORDER_W + R + row * V_STEP;
        // Trapezoid along exposed edge k (from vertex k to k+1), extending outward
        const borderTrap = (cx, cy, k)=>{
            const v1i = hexVertex(cx, cy, R, k);
            const v2i = hexVertex(cx, cy, R, (k + 1) % 6);
            const v1o = hexVertex(cx, cy, R + BORDER_W, k);
            const v2o = hexVertex(cx, cy, R + BORDER_W, (k + 1) % 6);
            return `${v1i.x},${v1i.y} ${v2i.x},${v2i.y} ${v2o.x},${v2o.y} ${v1o.x},${v1o.y}`;
        };
        // SVG dimensions
        const svgW = Math.ceil(2 * (PAD + BORDER_W + R) + (SIZE - 1 + (SIZE - 1) * 0.5) * W_HEX);
        const svgH = Math.ceil(2 * (PAD + BORDER_W + R) + (SIZE - 1) * V_STEP);
        // ── Border segments ──────────────────────────────────────────────────────
        // Exposed edges per border side (pointy-top hex, rows shift right):
        //   Neighbour (row-1, col)   shares edge 5  → row=0  exposes edge 5
        //   Neighbour (row-1, col+1) shares edge 0  → row=0  exposes edge 0
        //   Neighbour (row+1, col)   shares edge 2  → row=10 exposes edge 2
        //   Neighbour (row+1, col-1) shares edge 3  → row=10 exposes edge 3
        //   Neighbour (row, col-1)   shares edge 4  → col=0  exposes edge 4
        //   Neighbour (row+1, col-1) shares edge 3  → col=0  exposes edge 3
        //   Neighbour (row, col+1)   shares edge 1  → col=10 exposes edge 1
        //   Neighbour (row-1, col+1) shares edge 0  → col=10 exposes edge 0
        // Blue drawn first; red drawn on top (red wins at the two obtuse corners).
        const blueBorders = [];
        const redBorders = [];
        for(let row = 0; row < SIZE; row++)for(let col = 0; col < SIZE; col++){
            const cx = cellCx(row, col);
            const cy = cellCy(row);
            // Top row → RED edges 5, 0
            if (row === 0) {
                redBorders.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                    points: borderTrap(cx, cy, 5),
                    fill: RED_COLOR
                }, `rt-${col}-5`));
                redBorders.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                    points: borderTrap(cx, cy, 0),
                    fill: RED_COLOR
                }, `rt-${col}-0`));
            }
            // Bottom row → RED edges 2, 3
            if (row === SIZE - 1) {
                redBorders.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                    points: borderTrap(cx, cy, 2),
                    fill: RED_COLOR
                }, `rb-${col}-2`));
                redBorders.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                    points: borderTrap(cx, cy, 3),
                    fill: RED_COLOR
                }, `rb-${col}-3`));
            }
            // Left col → BLUE edge 4 always; edge 3 when not bottom row
            if (col === 0) {
                blueBorders.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                    points: borderTrap(cx, cy, 4),
                    fill: BLUE_COLOR
                }, `bl-${row}-4`));
                if (row < SIZE - 1) blueBorders.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                    points: borderTrap(cx, cy, 3),
                    fill: BLUE_COLOR
                }, `bl-${row}-3`));
            }
            // Right col → BLUE edge 1 always; edge 0 when not top row
            if (col === SIZE - 1) {
                blueBorders.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                    points: borderTrap(cx, cy, 1),
                    fill: BLUE_COLOR
                }, `br-${row}-1`));
                if (row > 0) blueBorders.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                    points: borderTrap(cx, cy, 0),
                    fill: BLUE_COLOR
                }, `br-${row}-0`));
            }
        }
        // ── Cells & pieces ───────────────────────────────────────────────────────
        const cells = [];
        for(let row = 0; row < SIZE; row++)for(let col = 0; col < SIZE; col++){
            const cx = cellCx(row, col);
            const cy = cellCy(row);
            const index = coordsToIndex(row, col);
            const piece = board[index];
            const isHovered = hoveredCell === index && !piece && !winner;
            cells.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        points: hexPoints(cx, cy, CELL_R),
                        fill: isHovered ? '#e8e0d0' : '#f5f0e1',
                        stroke: "#b8a88a",
                        strokeWidth: 1.5,
                        "data-row": row,
                        "data-col": col,
                        style: {
                            cursor: !piece && !winner ? 'pointer' : 'default'
                        }
                    }),
                    piece === 'red' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: cx,
                        cy: cy,
                        r: CELL_R * 0.6,
                        fill: RED_COLOR,
                        stroke: "#a01030",
                        strokeWidth: 2,
                        pointerEvents: "none"
                    }),
                    piece === 'blue' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: cx,
                        cy: cy,
                        r: CELL_R * 0.6,
                        fill: BLUE_COLOR,
                        stroke: "#0d3a7a",
                        strokeWidth: 2,
                        pointerEvents: "none"
                    })
                ]
            }, `cell-${row}-${col}`));
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "hex-board",
            onClick: handleSVGClick,
            onMouseOver: handleSVGMouseOver,
            onMouseOut: handleSVGMouseOut,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: `0 0 ${svgW} ${svgH}`,
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    blueBorders,
                    redBorders,
                    cells
                ]
            })
        });
    };
    // Show player configuration screen before game starts
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Hex"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Player Configuration"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Player 1 (Red)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'human'),
                                        children: "Human"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'computer'),
                                        children: "Computer"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Player 2 (Blue)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'human'),
                                        children: "Human"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'computer'),
                                        children: "Computer"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Start Game"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container hex-game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Hex"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            renderBoard(),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "New Game"
            })
        ]
    });
};
var $3b6981476d25eccc$export$2e2bcd8739ae039 = $3b6981476d25eccc$var$Hex;




var $acw62 = parcelRequire("acw62");

/**
 * Checkers Game Component
 * 
 * Game Rules:
 * - 8x8 checkered board where only dark squares are used for gameplay
 * - Each player starts with 12 pieces on the three nearest rows of dark squares
 * - Pieces move diagonally forward one square
 * - Pieces capture by jumping over opponent's piece to empty space beyond
 * - Multiple captures in one move are allowed and mandatory if available
 * - Pieces become "kings" when reaching opponent's back row
 * - Kings can move diagonally both forward and backward
 * - Game ends when one player has no pieces or no valid moves
 */ const $2b62029c4c661a69$var$Checkers = ()=>{
    // Initialize board with pieces
    const initializeBoard = ()=>{
        const board = Array(64).fill(null);
        // Dark squares on an 8x8 checkerboard (standard positions)
        // Rows 0-2: Black pieces (player 2)
        // Rows 5-7: Red pieces (player 1)
        for(let row = 0; row < 8; row++)for(let col = 0; col < 8; col++){
            const index = row * 8 + col;
            const isDarkSquare = (row + col) % 2 === 1;
            if (isDarkSquare) {
                if (row < 3) board[index] = {
                    player: 2,
                    isKing: false
                }; // Black pieces
                else if (row > 4) board[index] = {
                    player: 1,
                    isKing: false
                }; // Red pieces
            }
        }
        return board;
    };
    const [board, setBoard] = (0, $acw62.useState)(initializeBoard());
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)(1); // Player 1 (red) starts
    const [selectedPiece, setSelectedPiece] = (0, $acw62.useState)(null);
    const [validMoves, setValidMoves] = (0, $acw62.useState)([]);
    const [winner, setWinner] = (0, $acw62.useState)(null);
    const [mustContinueCapture, setMustContinueCapture] = (0, $acw62.useState)(null);
    /**
   * Get row and column from board index
   */ const getRowCol = (index)=>{
        return {
            row: Math.floor(index / 8),
            col: index % 8
        };
    };
    /**
   * Get board index from row and column
   */ const getIndex = (row, col)=>{
        if (row < 0 || row > 7 || col < 0 || col > 7) return null;
        return row * 8 + col;
    };
    /**
   * Check if a square is a dark square (playable)
   */ const isDarkSquare = (row, col)=>{
        return (row + col) % 2 === 1;
    };
    /**
   * Get all possible moves for a piece at the given index
   * Returns object with simple moves and captures
   */ const getPossibleMoves = (index, currentBoard = board)=>{
        const piece = currentBoard[index];
        if (!piece) return {
            simple: [],
            captures: []
        };
        const { row: row, col: col } = getRowCol(index);
        const simple = [];
        const captures = [];
        // Determine movement directions based on piece type
        const directions = piece.isKing ? [
            [
                -1,
                -1
            ],
            [
                -1,
                1
            ],
            [
                1,
                -1
            ],
            [
                1,
                1
            ]
        ] // Kings move in all diagonal directions
         : piece.player === 1 ? [
            [
                -1,
                -1
            ],
            [
                -1,
                1
            ]
        ] // Red moves up (negative row direction)
         : [
            [
                1,
                -1
            ],
            [
                1,
                1
            ]
        ]; // Black moves down (positive row direction)
        for (const [dRow, dCol] of directions){
            const newRow = row + dRow;
            const newCol = col + dCol;
            const newIndex = getIndex(newRow, newCol);
            if (newIndex !== null && isDarkSquare(newRow, newCol)) {
                const targetSquare = currentBoard[newIndex];
                // Simple move (empty square)
                if (!targetSquare) simple.push(newIndex);
                else if (targetSquare.player !== piece.player) {
                    const jumpRow = newRow + dRow;
                    const jumpCol = newCol + dCol;
                    const jumpIndex = getIndex(jumpRow, jumpCol);
                    if (jumpIndex !== null && isDarkSquare(jumpRow, jumpCol) && !currentBoard[jumpIndex]) captures.push({
                        to: jumpIndex,
                        captured: newIndex
                    });
                }
            }
        }
        return {
            simple: simple,
            captures: captures
        };
    };
    /**
   * Check if any piece of the current player has a capture available
   */ const hasAvailableCaptures = (player, currentBoard = board)=>{
        for(let i = 0; i < 64; i++){
            const piece = currentBoard[i];
            if (piece && piece.player === player) {
                const { captures: captures } = getPossibleMoves(i, currentBoard);
                if (captures.length > 0) return true;
            }
        }
        return false;
    };
    /**
   * Get all valid moves for a selected piece
   * If captures are available anywhere for the player, only captures are valid
   */ const getValidMovesForPiece = (index)=>{
        const moves = getPossibleMoves(index);
        // If this is a continuation of a multi-capture, only show capture moves from this piece
        if (mustContinueCapture !== null && mustContinueCapture === index) return moves.captures.map((c)=>c.to);
        // If any piece can capture, only captures are valid
        if (hasAvailableCaptures(currentPlayer)) return moves.captures.map((c)=>c.to);
        // Otherwise, return all simple moves
        return moves.simple;
    };
    /**
   * Check if a move results in a king promotion
   */ const shouldPromoteToKing = (index, player)=>{
        const { row: row } = getRowCol(index);
        return player === 1 && row === 0 || player === 2 && row === 7;
    };
    /**
   * Handle clicking on a board square
   */ const handleSquareClick = (index)=>{
        if (winner) return;
        const piece = board[index];
        const { row: row, col: col } = getRowCol(index);
        // Can only click on dark squares
        if (!isDarkSquare(row, col)) return;
        // If continuing a multi-capture, can only click on valid move squares
        if (mustContinueCapture !== null) {
            if (validMoves.includes(index)) performMove(mustContinueCapture, index);
            return;
        }
        // Selecting own piece
        if (piece && piece.player === currentPlayer) {
            setSelectedPiece(index);
            const moves = getValidMovesForPiece(index);
            setValidMoves(moves);
        } else if (selectedPiece !== null && validMoves.includes(index)) performMove(selectedPiece, index);
        else {
            setSelectedPiece(null);
            setValidMoves([]);
        }
    };
    /**
   * Perform a move from one square to another
   */ const performMove = (fromIndex, toIndex)=>{
        const newBoard = [
            ...board
        ];
        const piece = newBoard[fromIndex];
        const { row: fromRow, col: fromCol } = getRowCol(fromIndex);
        const { row: toRow, col: toCol } = getRowCol(toIndex);
        // Check if this is a capture move
        const rowDiff = Math.abs(toRow - fromRow);
        const isCapture = rowDiff === 2;
        if (isCapture) {
            // Remove captured piece
            const capturedRow = (fromRow + toRow) / 2;
            const capturedCol = (fromCol + toCol) / 2;
            const capturedIndex = getIndex(capturedRow, capturedCol);
            newBoard[capturedIndex] = null;
        }
        // Move the piece
        newBoard[toIndex] = {
            ...piece
        };
        newBoard[fromIndex] = null;
        // Check for king promotion
        if (shouldPromoteToKing(toIndex, piece.player)) newBoard[toIndex].isKing = true;
        setBoard(newBoard);
        // Check for multi-capture
        if (isCapture) {
            const { captures: captures } = getPossibleMoves(toIndex, newBoard);
            if (captures.length > 0) {
                // Must continue capturing
                setMustContinueCapture(toIndex);
                setSelectedPiece(toIndex);
                setValidMoves(captures.map((c)=>c.to));
                return;
            }
        }
        // Move complete, switch players
        setSelectedPiece(null);
        setValidMoves([]);
        setMustContinueCapture(null);
        const nextPlayer = currentPlayer === 1 ? 2 : 1;
        // Check if next player has any valid moves
        if (!hasAnyValidMoves(nextPlayer, newBoard)) setWinner(currentPlayer);
        else setCurrentPlayer(nextPlayer);
    };
    /**
   * Check if a player has any valid moves
   */ const hasAnyValidMoves = (player, currentBoard = board)=>{
        let hasCaptures = false;
        let hasSimpleMoves = false;
        // Single loop to check both captures and simple moves
        for(let i = 0; i < 64; i++){
            const piece = currentBoard[i];
            if (piece && piece.player === player) {
                const { simple: simple, captures: captures } = getPossibleMoves(i, currentBoard);
                if (captures.length > 0) {
                    hasCaptures = true;
                    return true; // If captures exist, they're always valid moves
                }
                if (simple.length > 0) hasSimpleMoves = true;
            }
        }
        // If no captures found, simple moves are valid
        return hasSimpleMoves;
    };
    /**
   * Reset the game
   */ const resetGame = ()=>{
        setBoard(initializeBoard());
        setCurrentPlayer(1);
        setSelectedPiece(null);
        setValidMoves([]);
        setWinner(null);
        setMustContinueCapture(null);
    };
    /**
   * Render the content of a square
   */ const renderSquare = (index)=>{
        const piece = board[index];
        if (!piece) return null;
        if (piece.player === 1) return piece.isKing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$aeb8eb29e25d3553), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$292502e69932201e), {});
        else return piece.isKing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$162e8ff728aa727a), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$b17398f8cd257797), {});
    };
    /**
   * Get the status message
   */ const getStatus = ()=>{
        if (winner) {
            const winnerName = winner === 1 ? 'Vermelhas' : 'Pretas';
            return `Vencedor: ${winnerName}!`;
        } else if (mustContinueCapture !== null) return "Continua a capturar com a pe\xe7a selecionada!";
        else {
            const playerName = currentPlayer === 1 ? 'Vermelhas' : 'Pretas';
            return `Turno: ${playerName}`;
        }
    };
    /**
   * Get CSS class for a square
   */ const getSquareClass = (index)=>{
        const { row: row, col: col } = getRowCol(index);
        const isLight = (row + col) % 2 === 0;
        const isSelected = selectedPiece === index;
        const isValidMove = validMoves.includes(index);
        let className = 'checkers-square';
        if (isLight) className += ' light-square';
        else className += ' dark-square';
        if (isSelected) className += ' selected';
        if (isValidMove) className += ' valid-move';
        return className;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Damas"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "checkers-board",
                children: board.map((_, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: getSquareClass(index),
                        onClick: ()=>handleSquareClick(index),
                        disabled: winner !== null,
                        children: renderSquare(index)
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "Novo Jogo"
            })
        ]
    });
};
var $2b62029c4c661a69$export$2e2bcd8739ae039 = $2b62029c4c661a69$var$Checkers;




var $acw62 = parcelRequire("acw62");

/**
 * Nine Men's Morris Game Component
 * 
 * Game Rules:
 * - Each player has 9 pieces
 * - Game has three phases:
 *   1. Placement: Players alternate placing pieces on empty positions
 *   2. Movement: Players move pieces to adjacent empty positions
 *   3. Flying: When a player has only 3 pieces left, they can move to any empty position
 * - Forming a "mill" (3 pieces in a row) allows removing an opponent's piece
 * - A player wins when opponent has only 2 pieces or cannot make a move
 */ const $67d74e7c9903d973$var$NineMensMorris = ()=>{
    // Board state: array of 24 positions (null, 1 for player 1, 2 for player 2)
    const [board, setBoard] = (0, $acw62.useState)(Array(24).fill(null));
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)(1);
    const [phase, setPhase] = (0, $acw62.useState)('placement'); // 'placement', 'movement', 'removal'
    const [piecesToPlace, setPiecesToPlace] = (0, $acw62.useState)({
        1: 9,
        2: 9
    });
    const [selectedPiece, setSelectedPiece] = (0, $acw62.useState)(null);
    const [validMoves, setValidMoves] = (0, $acw62.useState)([]);
    const [winner, setWinner] = (0, $acw62.useState)(null);
    const [millFormed, setMillFormed] = (0, $acw62.useState)(false);
    // Define adjacency connections for each position
    const adjacencyList = {
        0: [
            1,
            7
        ],
        1: [
            0,
            2,
            9
        ],
        2: [
            1,
            3
        ],
        3: [
            2,
            4,
            11
        ],
        4: [
            3,
            5
        ],
        5: [
            4,
            6,
            13
        ],
        6: [
            5,
            7
        ],
        7: [
            6,
            0,
            15
        ],
        8: [
            9,
            15
        ],
        9: [
            8,
            10,
            1,
            17
        ],
        10: [
            9,
            11
        ],
        11: [
            10,
            12,
            3,
            19
        ],
        12: [
            11,
            13
        ],
        13: [
            12,
            14,
            5,
            21
        ],
        14: [
            13,
            15
        ],
        15: [
            14,
            8,
            7,
            23
        ],
        16: [
            17,
            23
        ],
        17: [
            16,
            18,
            9
        ],
        18: [
            17,
            19
        ],
        19: [
            18,
            20,
            11
        ],
        20: [
            19,
            21
        ],
        21: [
            20,
            22,
            13
        ],
        22: [
            21,
            23
        ],
        23: [
            22,
            16,
            15
        ]
    };
    // Define all possible mills (3 positions that form a line)
    const mills = [
        // Outer square
        [
            0,
            1,
            2
        ],
        [
            2,
            3,
            4
        ],
        [
            4,
            5,
            6
        ],
        [
            6,
            7,
            0
        ],
        // Middle square
        [
            8,
            9,
            10
        ],
        [
            10,
            11,
            12
        ],
        [
            12,
            13,
            14
        ],
        [
            14,
            15,
            8
        ],
        // Inner square
        [
            16,
            17,
            18
        ],
        [
            18,
            19,
            20
        ],
        [
            20,
            21,
            22
        ],
        [
            22,
            23,
            16
        ],
        // Vertical connections
        [
            1,
            9,
            17
        ],
        [
            3,
            11,
            19
        ],
        [
            5,
            13,
            21
        ],
        [
            7,
            15,
            23
        ]
    ];
    /**
   * Check if a position is part of a mill for the given player
   */ const isPartOfMill = (position, player, currentBoard = board)=>{
        return mills.some((mill)=>{
            return mill.includes(position) && mill.every((pos)=>currentBoard[pos] === player);
        });
    };
    /**
   * Check if forming a mill after placing/moving to a position
   */ const checkMillFormed = (position, player, currentBoard)=>{
        return isPartOfMill(position, player, currentBoard);
    };
    /**
   * Get count of pieces for a player on the board
   */ const getPieceCount = (player)=>{
        return board.filter((p)=>p === player).length;
    };
    /**
   * Check if a player can make any valid move
   */ const hasValidMoves = (player)=>{
        // Check if any piece can move to an adjacent empty position
        for(let i = 0; i < 24; i++)if (board[i] === player) {
            // If player has 3 pieces, they can fly anywhere
            if (getPieceCount(player) === 3) {
                if (board.some((p)=>p === null)) return true;
            } else {
                // Check adjacent positions
                const adjacent = adjacencyList[i];
                if (adjacent.some((adj)=>board[adj] === null)) return true;
            }
        }
        return false;
    };
    /**
   * Check for win condition
   */ (0, $acw62.useEffect)(()=>{
        if (phase === 'placement') return;
        const opponent = currentPlayer === 1 ? 2 : 1;
        const opponentPieceCount = getPieceCount(opponent);
        // Win if opponent has only 2 pieces
        if (opponentPieceCount < 3) {
            setWinner(currentPlayer);
            return;
        }
        // Win if opponent has no valid moves
        if (!hasValidMoves(opponent) && !millFormed) setWinner(currentPlayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPlayer,
        phase,
        board
    ]);
    /**
   * Handle position click
   */ const handlePositionClick = (position)=>{
        if (winner) return;
        // Removal phase - remove opponent's piece
        if (millFormed) {
            const opponent = currentPlayer === 1 ? 2 : 1;
            if (board[position] === opponent) {
                // Cannot remove piece that's part of a mill unless all pieces are in mills
                const allInMills = board.every((p, idx)=>{
                    if (p !== opponent) return true;
                    return isPartOfMill(idx, opponent);
                });
                if (!isPartOfMill(position, opponent) || allInMills) {
                    const newBoard = [
                        ...board
                    ];
                    newBoard[position] = null;
                    setBoard(newBoard);
                    setMillFormed(false);
                    // Check if game should transition to movement phase
                    if (piecesToPlace[1] === 0 && piecesToPlace[2] === 0) setPhase('movement');
                    // After removing opponent's piece, switch to opponent's turn
                    // (currentPlayer formed the mill, removed a piece, now it's opponent's turn)
                    setCurrentPlayer(opponent);
                    setValidMoves([]);
                }
            }
            return;
        }
        // Placement phase
        if (phase === 'placement') {
            if (board[position] === null && piecesToPlace[currentPlayer] > 0) {
                const newBoard = [
                    ...board
                ];
                newBoard[position] = currentPlayer;
                setBoard(newBoard);
                const newPiecesToPlace = {
                    ...piecesToPlace
                };
                newPiecesToPlace[currentPlayer]--;
                setPiecesToPlace(newPiecesToPlace);
                // Check if mill was formed
                if (checkMillFormed(position, currentPlayer, newBoard)) setMillFormed(true);
                else {
                    // Switch player
                    const nextPlayer = currentPlayer === 1 ? 2 : 1;
                    setCurrentPlayer(nextPlayer);
                    // Check if placement phase is over
                    if (newPiecesToPlace[1] === 0 && newPiecesToPlace[2] === 0) setPhase('movement');
                }
            }
            return;
        }
        // Movement phase
        if (phase === 'movement') {
            // Select a piece
            if (board[position] === currentPlayer && selectedPiece === null) {
                setSelectedPiece(position);
                // Calculate valid moves
                const playerPieceCount = getPieceCount(currentPlayer);
                let valid = [];
                if (playerPieceCount === 3) // Flying: can move to any empty position
                valid = board.map((p, idx)=>p === null ? idx : null).filter((idx)=>idx !== null);
                else // Normal movement: can only move to adjacent empty positions
                valid = adjacencyList[position].filter((adj)=>board[adj] === null);
                setValidMoves(valid);
            } else if (selectedPiece !== null && validMoves.includes(position)) {
                const newBoard = [
                    ...board
                ];
                newBoard[selectedPiece] = null;
                newBoard[position] = currentPlayer;
                setBoard(newBoard);
                setSelectedPiece(null);
                setValidMoves([]);
                // Check if mill was formed
                if (checkMillFormed(position, currentPlayer, newBoard)) setMillFormed(true);
                else // Switch player
                setCurrentPlayer(currentPlayer === 1 ? 2 : 1);
            } else if (position === selectedPiece) {
                setSelectedPiece(null);
                setValidMoves([]);
            } else if (board[position] === currentPlayer) {
                setSelectedPiece(position);
                // Calculate valid moves for new piece
                const playerPieceCount = getPieceCount(currentPlayer);
                let valid = [];
                if (playerPieceCount === 3) valid = board.map((p, idx)=>p === null ? idx : null).filter((idx)=>idx !== null);
                else valid = adjacencyList[position].filter((adj)=>board[adj] === null);
                setValidMoves(valid);
            }
        }
    };
    /**
   * Reset game
   */ const resetGame = ()=>{
        setBoard(Array(24).fill(null));
        setCurrentPlayer(1);
        setPhase('placement');
        setPiecesToPlace({
            1: 9,
            2: 9
        });
        setSelectedPiece(null);
        setValidMoves([]);
        setWinner(null);
        setMillFormed(false);
    };
    /**
   * Get game status message
   */ const getStatus = ()=>{
        const colour = currentPlayer === 1 ? 'Brancas' : 'Pretas';
        if (winner) return `Vencedor: ${winner === 1 ? 'Brancas' : 'Pretas'}!`;
        if (millFormed) return `${colour}: remover pe\xe7a advers\xe1ria`;
        if (phase === 'placement') return `${colour}: colocar pe\xe7a (${piecesToPlace[currentPlayer]} restantes)`;
        if (phase === 'movement') {
            const canFly = getPieceCount(currentPlayer) === 3;
            return `${colour}: ${canFly ? "mover pe\xe7a em voo" : "mover pe\xe7a"}`;
        }
        return '';
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Moinho"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d9cc854c7c12ba8$export$99f01ec413cf1a3f), {
                board: board,
                onPositionClick: handlePositionClick,
                validMoves: validMoves
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "Novo Jogo"
            })
        ]
    });
};
var $67d74e7c9903d973$export$2e2bcd8739ae039 = $67d74e7c9903d973$var$NineMensMorris;




var $acw62 = parcelRequire("acw62");
/**
 * Fox and Geese board game component.
 *
 * The board is a cross-shaped grid with 33 valid points arranged in a 7×7
 * coordinate space. Geese move forward/sideways only; the fox moves freely
 * and captures by jumping over adjacent geese into empty squares.
 */ // All 33 valid board points in (row, col) coordinates on a 7×7 grid
const $8e3009e73d7d2f4c$var$POINTS = [
    // Row 0: top arm
    {
        row: 0,
        col: 2
    },
    {
        row: 0,
        col: 3
    },
    {
        row: 0,
        col: 4
    },
    // Row 1: top arm
    {
        row: 1,
        col: 2
    },
    {
        row: 1,
        col: 3
    },
    {
        row: 1,
        col: 4
    },
    // Row 2: full row
    {
        row: 2,
        col: 0
    },
    {
        row: 2,
        col: 1
    },
    {
        row: 2,
        col: 2
    },
    {
        row: 2,
        col: 3
    },
    {
        row: 2,
        col: 4
    },
    {
        row: 2,
        col: 5
    },
    {
        row: 2,
        col: 6
    },
    // Row 3: centre row
    {
        row: 3,
        col: 0
    },
    {
        row: 3,
        col: 1
    },
    {
        row: 3,
        col: 2
    },
    {
        row: 3,
        col: 3
    },
    {
        row: 3,
        col: 4
    },
    {
        row: 3,
        col: 5
    },
    {
        row: 3,
        col: 6
    },
    // Row 4: full row
    {
        row: 4,
        col: 0
    },
    {
        row: 4,
        col: 1
    },
    {
        row: 4,
        col: 2
    },
    {
        row: 4,
        col: 3
    },
    {
        row: 4,
        col: 4
    },
    {
        row: 4,
        col: 5
    },
    {
        row: 4,
        col: 6
    },
    // Row 5: bottom arm
    {
        row: 5,
        col: 2
    },
    {
        row: 5,
        col: 3
    },
    {
        row: 5,
        col: 4
    },
    // Row 6: bottom arm
    {
        row: 6,
        col: 2
    },
    {
        row: 6,
        col: 3
    },
    {
        row: 6,
        col: 4
    }
];
// Map "row,col" -> index for quick lookups
const $8e3009e73d7d2f4c$var$POS_TO_IDX = {};
$8e3009e73d7d2f4c$var$POINTS.forEach(({ row: row, col: col }, i)=>{
    $8e3009e73d7d2f4c$var$POS_TO_IDX[`${row},${col}`] = i;
});
/**
 * Adjacency list: two points are neighbours if their row and column each
 * differ by at most 1 (8-directional) and both are valid board points.
 */ const $8e3009e73d7d2f4c$var$ADJACENCY = $8e3009e73d7d2f4c$var$POINTS.map(({ row: row, col: col })=>{
    const neighbors = [];
    for(let dr = -1; dr <= 1; dr++)for(let dc = -1; dc <= 1; dc++){
        if (dr === 0 && dc === 0) continue;
        const key = `${row + dr},${col + dc}`;
        if ($8e3009e73d7d2f4c$var$POS_TO_IDX[key] !== undefined) neighbors.push($8e3009e73d7d2f4c$var$POS_TO_IDX[key]);
    }
    return neighbors;
});
// Index of the fox's starting position (row 3, col 3 – centre of the board)
const $8e3009e73d7d2f4c$var$FOX_START = $8e3009e73d7d2f4c$var$POS_TO_IDX['3,3']; // index 16
/**
 * Build the initial board state.
 * Geese (15) occupy:
 *   - Top arm rows 0–1, cols 2–4: indices 0–5
 *   - Full row 2 (cols 0–6): indices 6–12
 *   - Row 3 ends (cols 0 and 6): indices 13 and 19
 * Fox occupies the centre: index FOX_START.
 * @returns {Array} Initial board array of 33 entries
 */ const $8e3009e73d7d2f4c$var$buildInitialBoard = ()=>{
    const board = Array(33).fill(null);
    for(let i = 0; i <= 12; i++)board[i] = 'goose'; // top arm + row 2
    board[13] = 'goose'; // row 3, col 0
    board[19] = 'goose'; // row 3, col 6
    board[$8e3009e73d7d2f4c$var$FOX_START] = 'fox';
    return board;
};
// SVG layout constants
const $8e3009e73d7d2f4c$var$CELL = 100; // pixels per grid cell
const $8e3009e73d7d2f4c$var$PAD = 50; // offset so each point sits at the centre of its cell
const $8e3009e73d7d2f4c$var$R_PIECE = 48; // piece icon half-size
// Inline SVG content for Fox (front-facing head, cartoonish, cute)
const $8e3009e73d7d2f4c$var$FoxContent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 24 44 L 30 12 L 44 36 Z",
                fill: "#E8881F"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 76 44 L 70 12 L 56 36 Z",
                fill: "#E8881F"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 28 42 L 32 20 L 42 37 Z",
                fill: "#F7C87D"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 72 42 L 68 20 L 58 37 Z",
                fill: "#F7C87D"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "54",
                r: "30",
                fill: "#E8881F"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "60",
                rx: "20",
                ry: "20",
                fill: "#FADED0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "32",
                cy: "60",
                r: "6",
                fill: "#F0A060",
                opacity: "0.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "68",
                cy: "60",
                r: "6",
                fill: "#F0A060",
                opacity: "0.5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "40",
                cy: "50",
                rx: "4.5",
                ry: "5.5",
                fill: "#4A3728"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "60",
                cy: "50",
                rx: "4.5",
                ry: "5.5",
                fill: "#4A3728"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "42",
                cy: "48",
                r: "2",
                fill: "white",
                opacity: "0.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "62",
                cy: "48",
                r: "2",
                fill: "white",
                opacity: "0.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "63",
                rx: "4",
                ry: "3",
                fill: "#4A3728"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "49",
                cy: "62",
                rx: "1.5",
                ry: "1",
                fill: "white",
                opacity: "0.3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 46 66 Q 50 70 54 66",
                stroke: "#B06030",
                strokeWidth: "1.2",
                fill: "none",
                strokeLinecap: "round"
            })
        ]
    });
// Inline SVG content for Goose (front-facing head, cartoonish, cute)
const $8e3009e73d7d2f4c$var$GooseContent = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "50",
                rx: "28",
                ry: "30",
                fill: "#E8E8E4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "24",
                rx: "8",
                ry: "6",
                fill: "#D0D0CC"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "30",
                cy: "56",
                r: "6",
                fill: "#F0B8A0",
                opacity: "0.4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "70",
                cy: "56",
                r: "6",
                fill: "#F0B8A0",
                opacity: "0.4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "38",
                cy: "44",
                r: "4.5",
                fill: "#3A3A3A"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "62",
                cy: "44",
                r: "4.5",
                fill: "#3A3A3A"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "40",
                cy: "42",
                r: "2",
                fill: "white",
                opacity: "0.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "64",
                cy: "42",
                r: "2",
                fill: "white",
                opacity: "0.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "62",
                rx: "10",
                ry: "7",
                fill: "#E8A030"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "50",
                cy: "59",
                rx: "8",
                ry: "4",
                fill: "#F0B840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "47",
                cy: "61",
                r: "1.2",
                fill: "#C08020",
                opacity: "0.6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "53",
                cy: "61",
                r: "1.2",
                fill: "#C08020",
                opacity: "0.6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M 44 66 Q 50 70 56 66",
                stroke: "#C08020",
                strokeWidth: "1",
                fill: "none",
                strokeLinecap: "round"
            })
        ]
    });
/**
 * Fox and Geese game component.
 */ const $8e3009e73d7d2f4c$var$FoxAndGeese = ()=>{
    const [board, setBoard] = (0, $acw62.useState)($8e3009e73d7d2f4c$var$buildInitialBoard);
    const [currentTurn, setCurrentTurn] = (0, $acw62.useState)('goose'); // 'goose' or 'fox'
    const [selectedIdx, setSelectedIdx] = (0, $acw62.useState)(null);
    const [validMoves, setValidMoves] = (0, $acw62.useState)([]);
    const [winner, setWinner] = (0, $acw62.useState)(null); // 'fox' or 'goose'
    /**
	 * Returns valid destination indices for a goose at `from`.
	 * Geese may move forward (increasing row), diagonally forward, or sideways,
	 * but NOT backward (decreasing row).
	 * @param {number} from - Source index
	 * @param {Array} currentBoard - Current board state
	 * @returns {number[]} Valid destination indices
	 */ const getGooseMoves = (from, currentBoard)=>{
        const fromRow = $8e3009e73d7d2f4c$var$POINTS[from].row;
        return $8e3009e73d7d2f4c$var$ADJACENCY[from].filter((to)=>{
            if (currentBoard[to] !== null) return false;
            return $8e3009e73d7d2f4c$var$POINTS[to].row >= fromRow; // no backward movement
        });
    };
    /**
	 * Returns valid destination indices for the fox at `from`.
	 * Includes normal adjacent moves to empty squares plus capture jumps
	 * (hop over an adjacent goose into the empty square behind it).
	 * @param {number} from - Source index
	 * @param {Array} currentBoard - Current board state
	 * @returns {number[]} Valid destination indices
	 */ const getFoxMoves = (from, currentBoard)=>{
        const moves = [];
        const foxRow = $8e3009e73d7d2f4c$var$POINTS[from].row;
        const foxCol = $8e3009e73d7d2f4c$var$POINTS[from].col;
        // Normal adjacent moves to empty squares
        for (const to of $8e3009e73d7d2f4c$var$ADJACENCY[from])if (currentBoard[to] === null) moves.push(to);
        // Capture moves: jump over an adjacent goose into an empty square
        for (const gooseIdx of $8e3009e73d7d2f4c$var$ADJACENCY[from]){
            if (currentBoard[gooseIdx] !== 'goose') continue;
            const dr = $8e3009e73d7d2f4c$var$POINTS[gooseIdx].row - foxRow;
            const dc = $8e3009e73d7d2f4c$var$POINTS[gooseIdx].col - foxCol;
            const landKey = `${$8e3009e73d7d2f4c$var$POINTS[gooseIdx].row + dr},${$8e3009e73d7d2f4c$var$POINTS[gooseIdx].col + dc}`;
            const landIdx = $8e3009e73d7d2f4c$var$POS_TO_IDX[landKey];
            if (landIdx !== undefined && currentBoard[landIdx] === null) moves.push(landIdx);
        }
        return moves;
    };
    /**
	 * Check for a win condition after a move has been applied.
	 * @param {Array} newBoard - Board state after the move
	 * @param {'goose'|'fox'} nextTurn - Whose turn comes next
	 * @returns {'fox'|'goose'|null} Winner, or null if game continues
	 */ const checkWinner = (newBoard, nextTurn)=>{
        if (nextTurn === 'fox') {
            // Geese just moved – check if fox is trapped
            const foxIdx = newBoard.indexOf('fox');
            if (getFoxMoves(foxIdx, newBoard).length === 0) return 'goose';
        } else {
            // Fox just moved – check fox-wins conditions
            const geeseCount = newBoard.filter((c)=>c === 'goose').length;
            if (geeseCount < 3) return 'fox';
            const hasGooseMove = newBoard.some((cell, i)=>cell === 'goose' && getGooseMoves(i, newBoard).length > 0);
            if (!hasGooseMove) return 'fox';
        }
        return null;
    };
    /**
	 * Handle a click on board point at `idx`.
	 * @param {number} idx - Index of the clicked point
	 */ const handlePointClick = (idx)=>{
        if (winner) return;
        if (currentTurn === 'goose') {
            if (board[idx] === 'goose') {
                // Select or deselect a goose
                if (selectedIdx === idx) {
                    setSelectedIdx(null);
                    setValidMoves([]);
                } else {
                    setSelectedIdx(idx);
                    setValidMoves(getGooseMoves(idx, board));
                }
            } else if (selectedIdx !== null && validMoves.includes(idx)) {
                // Execute goose move
                const newBoard = [
                    ...board
                ];
                newBoard[idx] = 'goose';
                newBoard[selectedIdx] = null;
                setBoard(newBoard);
                setSelectedIdx(null);
                setValidMoves([]);
                const w = checkWinner(newBoard, 'fox');
                if (w) setWinner(w);
                else setCurrentTurn('fox');
            }
        } else {
            // Fox's turn
            const foxIdx = board.indexOf('fox');
            if (selectedIdx === null) {
                if (idx === foxIdx) {
                    setSelectedIdx(idx);
                    setValidMoves(getFoxMoves(idx, board));
                }
            } else if (validMoves.includes(idx)) {
                // Execute fox move (may include a capture)
                const newBoard = [
                    ...board
                ];
                const foxRow = $8e3009e73d7d2f4c$var$POINTS[foxIdx].row;
                const foxCol = $8e3009e73d7d2f4c$var$POINTS[foxIdx].col;
                const deltaRow = $8e3009e73d7d2f4c$var$POINTS[idx].row - foxRow;
                const deltaCol = $8e3009e73d7d2f4c$var$POINTS[idx].col - foxCol;
                // If the move is more than 1 step in any direction, it is a capture jump.
                // Capture jumps always span exactly 2 cells (deltaRow and deltaCol are
                // each 0 or ±2), so deltaRow/2 and deltaCol/2 are always integers.
                if (Math.abs(deltaRow) > 1 || Math.abs(deltaCol) > 1) {
                    const midKey = `${foxRow + deltaRow / 2},${foxCol + deltaCol / 2}`;
                    const midIdx = $8e3009e73d7d2f4c$var$POS_TO_IDX[midKey];
                    if (midIdx !== undefined && newBoard[midIdx] === 'goose') newBoard[midIdx] = null;
                }
                newBoard[foxIdx] = null;
                newBoard[idx] = 'fox';
                setBoard(newBoard);
                setSelectedIdx(null);
                setValidMoves([]);
                const w = checkWinner(newBoard, 'goose');
                if (w) setWinner(w);
                else setCurrentTurn('goose');
            } else if (idx === foxIdx) {
                // Deselect
                setSelectedIdx(null);
                setValidMoves([]);
            }
        }
    };
    /**
	 * Reset the game to its initial state.
	 */ const resetGame = ()=>{
        setBoard($8e3009e73d7d2f4c$var$buildInitialBoard());
        setCurrentTurn('goose');
        setSelectedIdx(null);
        setValidMoves([]);
        setWinner(null);
    };
    /**
	 * Build the current status message.
	 * @returns {string} Status text
	 */ const getStatus = ()=>{
        if (winner === 'fox') return 'Fox wins! The geese cannot trap the fox.';
        if (winner === 'goose') return 'Geese win! The fox is trapped.';
        if (currentTurn === 'goose') return "Geese's turn \u2013 select a goose to move";
        return "Fox's turn \u2013 select the fox to move";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Fox and Geese"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                viewBox: `0 0 ${7 * $8e3009e73d7d2f4c$var$CELL} ${7 * $8e3009e73d7d2f4c$var$CELL}`,
                className: "fox-and-geese-svg",
                role: "img",
                "aria-label": "Fox and Geese board",
                children: [
                    $8e3009e73d7d2f4c$var$POINTS.map((pt, i)=>$8e3009e73d7d2f4c$var$ADJACENCY[i].filter((j)=>j > i).map((j)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: pt.col * $8e3009e73d7d2f4c$var$CELL + $8e3009e73d7d2f4c$var$PAD,
                                y1: pt.row * $8e3009e73d7d2f4c$var$CELL + $8e3009e73d7d2f4c$var$PAD,
                                x2: $8e3009e73d7d2f4c$var$POINTS[j].col * $8e3009e73d7d2f4c$var$CELL + $8e3009e73d7d2f4c$var$PAD,
                                y2: $8e3009e73d7d2f4c$var$POINTS[j].row * $8e3009e73d7d2f4c$var$CELL + $8e3009e73d7d2f4c$var$PAD,
                                stroke: "#8b7355",
                                strokeWidth: 2
                            }, `${i}-${j}`))),
                    $8e3009e73d7d2f4c$var$POINTS.map((pt, i)=>{
                        const cx = pt.col * $8e3009e73d7d2f4c$var$CELL + $8e3009e73d7d2f4c$var$PAD;
                        const cy = pt.row * $8e3009e73d7d2f4c$var$CELL + $8e3009e73d7d2f4c$var$PAD;
                        const isSelected = selectedIdx === i;
                        const isValid = validMoves.includes(i);
                        const piece = board[i];
                        const isClickable = !winner && (currentTurn === 'goose' && (piece === 'goose' || isValid && selectedIdx !== null) || currentTurn === 'fox' && (piece === 'fox' || isValid && selectedIdx !== null));
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            onClick: ()=>handlePointClick(i),
                            style: {
                                cursor: isClickable ? 'pointer' : 'default'
                            },
                            "aria-label": piece ? `${piece === 'goose' ? 'Goose' : 'Fox'} at row ${pt.row} column ${pt.col}${isSelected ? ', selected' : ''}` : isValid ? `Valid move target at row ${pt.row} column ${pt.col}` : undefined,
                            role: piece || isValid ? 'button' : undefined,
                            children: [
                                isSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: cx,
                                    cy: cy,
                                    r: $8e3009e73d7d2f4c$var$R_PIECE + 6,
                                    fill: "#facc15",
                                    opacity: 0.55
                                }),
                                piece === 'goose' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    x: cx - $8e3009e73d7d2f4c$var$R_PIECE,
                                    y: cy - $8e3009e73d7d2f4c$var$R_PIECE,
                                    width: $8e3009e73d7d2f4c$var$R_PIECE * 2,
                                    height: $8e3009e73d7d2f4c$var$R_PIECE * 2,
                                    viewBox: "0 0 100 100",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8e3009e73d7d2f4c$var$GooseContent, {})
                                }),
                                piece === 'fox' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    x: cx - $8e3009e73d7d2f4c$var$R_PIECE,
                                    y: cy - $8e3009e73d7d2f4c$var$R_PIECE,
                                    width: $8e3009e73d7d2f4c$var$R_PIECE * 2,
                                    height: $8e3009e73d7d2f4c$var$R_PIECE * 2,
                                    viewBox: "0 0 100 100",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8e3009e73d7d2f4c$var$FoxContent, {})
                                }),
                                isValid && !piece && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: cx,
                                    cy: cy,
                                    r: 10,
                                    fill: "#4ade80",
                                    opacity: 0.85
                                }),
                                !piece && !isValid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: cx,
                                    cy: cy,
                                    r: 5,
                                    fill: "#8b7355"
                                })
                            ]
                        }, i);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "New Game"
            })
        ]
    });
};
var $8e3009e73d7d2f4c$export$2e2bcd8739ae039 = $8e3009e73d7d2f4c$var$FoxAndGeese;




var $acw62 = parcelRequire("acw62");
// Domineering Game Component
// Player 1 (Horizontal) places dominoes covering two adjacent cells in the same row.
// Player 2 (Vertical) places dominoes covering two adjacent cells in the same column.
// A player loses when they have no valid moves on their turn.
const $a761368a2ac1906f$var$Domineering = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        1: 'human',
        2: 'human'
    });
    const [board, setBoard] = (0, $acw62.useState)(Array(64).fill(null)); // 8x8 = 64 cells, null | 1 | 2
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)(1); // 1 = Horizontal, 2 = Vertical
    const [winner, setWinner] = (0, $acw62.useState)(null);
    /**
	 * Returns true if placing a domino at `index` for `player` is valid.
	 * Player 1 (Horizontal): covers (row, col) and (row, col+1)
	 * Player 2 (Vertical):   covers (row, col) and (row+1, col)
	 */ const isValidMove = (index, player, currentBoard)=>{
        const row = Math.floor(index / 8);
        const col = index % 8;
        if (player === 1) {
            // Horizontal: need col+1 within bounds and both cells empty
            if (col >= 7) return false;
            const right = index + 1;
            return currentBoard[index] === null && currentBoard[right] === null;
        } else {
            // Vertical: need row+1 within bounds and both cells empty
            if (row >= 7) return false;
            const below = index + 8;
            return currentBoard[index] === null && currentBoard[below] === null;
        }
    };
    /**
	 * Returns all valid move starting indices for a given player.
	 */ const getValidMoves = (player, currentBoard)=>{
        const moves = [];
        for(let i = 0; i < 64; i++)if (isValidMove(i, player, currentBoard)) moves.push(i);
        return moves;
    };
    /**
	 * Apply a move: mark both cells for the player and return the new board.
	 */ const applyMove = (index, player, currentBoard)=>{
        const newBoard = [
            ...currentBoard
        ];
        newBoard[index] = player;
        if (player === 1) newBoard[index + 1] = player;
        else newBoard[index + 8] = player;
        return newBoard;
    };
    /**
	 * Handle a cell click from a human player.
	 */ const handleClick = (index)=>{
        if (winner) return;
        if (playerTypes[currentPlayer] !== 'human') return;
        if (!isValidMove(index, currentPlayer, board)) return;
        const newBoard = applyMove(index, currentPlayer, board);
        setBoard(newBoard);
        const nextPlayer = currentPlayer === 1 ? 2 : 1;
        if (getValidMoves(nextPlayer, newBoard).length === 0) setWinner(currentPlayer);
        else setCurrentPlayer(nextPlayer);
    };
    /**
	 * Reset the game to the configuration screen.
	 */ const resetGame = ()=>{
        setBoard(Array(64).fill(null));
        setCurrentPlayer(1);
        setWinner(null);
        setGameStarted(false);
    };
    /**
	 * Start the game with chosen player types.
	 */ const startGame = ()=>{
        setGameStarted(true);
    };
    /**
	 * Handle player type toggle.
	 */ const handlePlayerTypeChange = (player, type)=>{
        setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    };
    // Computer player: pick a random valid move after a short delay.
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner) return;
        if (playerTypes[currentPlayer] !== 'computer') return;
        const timeoutId = setTimeout(()=>{
            const moves = getValidMoves(currentPlayer, board);
            if (moves.length === 0) {
                // No moves — opponent wins (should already be caught, but guard here)
                const nextPlayer = currentPlayer === 1 ? 2 : 1;
                setWinner(nextPlayer);
                return;
            }
            const move = moves[Math.floor(Math.random() * moves.length)];
            const newBoard = applyMove(move, currentPlayer, board);
            setBoard(newBoard);
            const nextPlayer = currentPlayer === 1 ? 2 : 1;
            if (getValidMoves(nextPlayer, newBoard).length === 0) setWinner(currentPlayer);
            else setCurrentPlayer(nextPlayer);
        }, 500);
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPlayer,
        gameStarted,
        winner,
        board,
        playerTypes
    ]);
    /**
	 * Current status message.
	 */ const getStatus = ()=>{
        if (winner) {
            const name = winner === 1 ? 'Player 1 (Horizontal)' : 'Player 2 (Vertical)';
            return `Winner: ${name}!`;
        }
        const name = currentPlayer === 1 ? 'Player 1 (Horizontal)' : 'Player 2 (Vertical)';
        return `Current Turn: ${name}`;
    };
    // ── Configuration screen ────────────────────────────────────────────────
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Domin\xf3rio"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Configura\xe7\xe3o de Jogadores"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador 1 (Horizontal)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador 2 (Vertical)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Iniciar Jogo"
            })
        ]
    });
    // ── Game board ──────────────────────────────────────────────────────────
    const isHumanTurn = playerTypes[currentPlayer] === 'human';
    const validMoveSet = new Set(!winner && isHumanTurn ? getValidMoves(currentPlayer, board) : []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Domin\xf3rio"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: "0 0 800 800",
                className: "domineering-svg",
                children: board.map((cell, index)=>{
                    const row = Math.floor(index / 8);
                    const col = index % 8;
                    const x = col * 100;
                    const y = row * 100;
                    const isValid = validMoveSet.has(index);
                    // Cell fill colour
                    let fill;
                    if (cell === 1) fill = '#93c5fd'; // blue for Player 1
                    else if (cell === 2) fill = '#fca5a5'; // red for Player 2
                    else if (isValid) fill = '#d1fae5'; // green tint for valid moves
                    else fill = '#f3f4f6'; // neutral
                    const isClickable = isValid && !winner;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        onClick: ()=>isClickable && handleClick(index),
                        style: {
                            cursor: isClickable ? 'pointer' : 'default'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: x + 2,
                                y: y + 2,
                                width: 96,
                                height: 96,
                                rx: 4,
                                fill: fill,
                                stroke: isValid ? '#6ee7b7' : '#d1d5db',
                                strokeWidth: isValid ? 2 : 1
                            }),
                            cell !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                x: x + 50,
                                y: y + 56,
                                textAnchor: "middle",
                                fontSize: "22",
                                fontWeight: "bold",
                                fill: cell === 1 ? '#1d4ed8' : '#b91c1c',
                                children: cell === 1 ? 'H' : 'V'
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "Novo Jogo"
            })
        ]
    });
};
var $a761368a2ac1906f$export$2e2bcd8739ae039 = $a761368a2ac1906f$var$Domineering;




var $acw62 = parcelRequire("acw62");

// Atari Go Game Component
/**
 * Atari Go: A two-player strategy game on a 9x9 Go board
 *
 * Game Rules:
 * - Players alternate placing stones (Player 1: Black, Player 2: White)
 * - A stone or connected group is captured when all its liberties are occupied
 * - The first player to capture at least one opponent stone wins
 * - Atari: a group with exactly one liberty is in danger of capture
 * - Ko rule: a move that repeats the immediately previous board state is illegal
 */ const $00886599104d87f2$var$AtariGo = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        1: 'human',
        2: 'human'
    });
    const [useCrossCut, setUseCrossCut] = (0, $acw62.useState)(false);
    const [board, setBoard] = (0, $acw62.useState)(Array(81).fill(null)); // 9x9 = 81 intersections
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)(1); // 1 = Black, 2 = White
    const [winner, setWinner] = (0, $acw62.useState)(null);
    const [lastBoard, setLastBoard] = (0, $acw62.useState)(null); // for Ko rule
    const [computerPlayer] = (0, $acw62.useState)(new (0, $dd249245bd2d6dab$export$2e2bcd8739ae039)());
    /**
	 * Convert row and column to board index
	 * @param {number} row - Row number (0-8)
	 * @param {number} col - Column number (0-8)
	 * @returns {number} - Board index
	 */ const coordsToIndex = (row, col)=>row * 9 + col;
    /**
	 * Convert board index to row and column
	 * @param {number} index - Board index
	 * @returns {Object} - {row, col}
	 */ const indexToCoords = (index)=>({
            row: Math.floor(index / 9),
            col: index % 9
        });
    /**
	 * Get the orthogonal neighbours of a cell
	 * @param {number} row - Row number
	 * @param {number} col - Column number
	 * @returns {Array<number>} - Array of neighbour indices
	 */ const getNeighbors = (row, col)=>{
        const neighbors = [];
        if (row > 0) neighbors.push(coordsToIndex(row - 1, col));
        if (row < 8) neighbors.push(coordsToIndex(row + 1, col));
        if (col > 0) neighbors.push(coordsToIndex(row, col - 1));
        if (col < 8) neighbors.push(coordsToIndex(row, col + 1));
        return neighbors;
    };
    /**
	 * BFS to find all stones of the same colour connected to the given index
	 * @param {Array} currentBoard - The current board state
	 * @param {number} index - Starting index
	 * @returns {Set<number>} - Set of indices in the group
	 */ const getGroup = (currentBoard, index)=>{
        const color = currentBoard[index];
        if (!color) return new Set();
        const group = new Set();
        const queue = [
            index
        ];
        group.add(index);
        while(queue.length > 0){
            const current = queue.shift();
            const { row: row, col: col } = indexToCoords(current);
            for (const neighbor of getNeighbors(row, col))if (!group.has(neighbor) && currentBoard[neighbor] === color) {
                group.add(neighbor);
                queue.push(neighbor);
            }
        }
        return group;
    };
    /**
	 * Get the set of empty intersections adjacent to the group (liberties)
	 * @param {Array} currentBoard - The current board state
	 * @param {Set<number>} group - Set of indices in the group
	 * @returns {Set<number>} - Set of liberty indices
	 */ const getLiberties = (currentBoard, group)=>{
        const liberties = new Set();
        for (const index of group){
            const { row: row, col: col } = indexToCoords(index);
            for (const neighbor of getNeighbors(row, col))if (currentBoard[neighbor] === null) liberties.add(neighbor);
        }
        return liberties;
    };
    /**
	 * Check if the group containing the given index is in Atari (exactly 1 liberty)
	 * @param {Array} currentBoard - The current board state
	 * @param {number} index - Index to check
	 * @returns {boolean} - True if in Atari
	 */ const isInAtari = (currentBoard, index)=>{
        if (!currentBoard[index]) return false;
        const group = getGroup(currentBoard, index);
        return getLiberties(currentBoard, group).size === 1;
    };
    /**
	 * Remove all opponent groups with zero liberties and return capture count
	 * @param {Array} currentBoard - The board after a stone was placed
	 * @param {number} opponentColor - 1 or 2
	 * @returns {{ newBoard: Array, capturedCount: number }}
	 */ const performCaptures = (currentBoard, opponentColor)=>{
        const newBoard = [
            ...currentBoard
        ];
        let capturedCount = 0;
        const visited = new Set();
        for(let i = 0; i < 81; i++)if (newBoard[i] === opponentColor && !visited.has(i)) {
            const group = getGroup(newBoard, i);
            group.forEach((idx)=>visited.add(idx));
            if (getLiberties(newBoard, group).size === 0) {
                capturedCount += group.size;
                group.forEach((idx)=>{
                    newBoard[idx] = null;
                });
            }
        }
        return {
            newBoard: newBoard,
            capturedCount: capturedCount
        };
    };
    /**
	 * Check if newBoard is identical to lastBoard (Ko rule)
	 * @param {Array} newBoard - Board after the move
	 * @param {Array|null} prevBoard - Board before the previous move
	 * @returns {boolean} - True if the move would repeat the previous position
	 */ const isKo = (newBoard, prevBoard)=>{
        if (!prevBoard) return false;
        for(let i = 0; i < 81; i++){
            if (newBoard[i] !== prevBoard[i]) return false;
        }
        return true;
    };
    /**
	 * Handle a click on a board intersection
	 * @param {number} row - Row of clicked intersection
	 * @param {number} col - Column of clicked intersection
	 */ const handleClick = (0, $acw62.useCallback)((row, col)=>{
        const index = coordsToIndex(row, col);
        if (winner || board[index] !== null) return;
        // Place stone
        const newBoard = [
            ...board
        ];
        newBoard[index] = currentPlayer;
        // Capture opponent groups with no liberties
        const opponentColor = currentPlayer === 1 ? 2 : 1;
        const { newBoard: boardAfterCapture, capturedCount: capturedCount } = performCaptures(newBoard, opponentColor);
        // Ko rule: reject move if it recreates the previous board state
        if (isKo(boardAfterCapture, lastBoard)) return;
        setLastBoard(board);
        setBoard(boardAfterCapture);
        if (capturedCount > 0) setWinner(currentPlayer);
        else setCurrentPlayer(opponentColor);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        board,
        currentPlayer,
        winner,
        lastBoard
    ]);
    /**
	 * Reset the game to the configuration screen
	 */ const resetGame = ()=>{
        setBoard(Array(81).fill(null));
        setCurrentPlayer(1);
        setWinner(null);
        setLastBoard(null);
        setGameStarted(false);
    };
    /**
	 * Start the game, optionally with the cross-cut formation
	 */ const startGame = ()=>{
        if (useCrossCut) {
            const initial = Array(81).fill(null);
            // Cross-cut formation at centre: (3,3)=Black, (3,5)=White, (5,3)=White, (5,5)=Black
            initial[coordsToIndex(3, 3)] = 1;
            initial[coordsToIndex(3, 5)] = 2;
            initial[coordsToIndex(5, 3)] = 2;
            initial[coordsToIndex(5, 5)] = 1;
            setBoard(initial);
        } else setBoard(Array(81).fill(null));
        setGameStarted(true);
    };
    /**
	 * Handle player type selection
	 */ const handlePlayerTypeChange = (player, type)=>{
        setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    };
    // Computer player: pick a random valid (non-Ko) empty cell
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner) return;
        if (playerTypes[currentPlayer] !== 'computer') return;
        const timeoutId = setTimeout(()=>{
            // Gather all valid moves
            const validMoves = [];
            for(let i = 0; i < 81; i++){
                if (board[i] !== null) continue;
                const { row: row, col: col } = indexToCoords(i);
                const testBoard = [
                    ...board
                ];
                testBoard[i] = currentPlayer;
                const opponentColor = currentPlayer === 1 ? 2 : 1;
                const { newBoard: boardAfterCapture } = performCaptures(testBoard, opponentColor);
                if (!isKo(boardAfterCapture, lastBoard)) validMoves.push({
                    row: row,
                    col: col
                });
            }
            if (validMoves.length > 0) {
                const move = validMoves[Math.floor(Math.random() * validMoves.length)];
                handleClick(move.row, move.col);
            }
        }, 500);
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPlayer,
        gameStarted,
        winner,
        board,
        playerTypes,
        computerPlayer,
        handleClick
    ]);
    /**
	 * Get current game status message
	 * @returns {string}
	 */ const getStatus = ()=>{
        if (winner) {
            const name = winner === 1 ? 'Pretas' : 'Brancas';
            return `Vencedor: ${name}!`;
        }
        const name = currentPlayer === 1 ? 'Pretas' : 'Brancas';
        return `Turno: ${name}`;
    };
    // SVG board constants
    const CELL_SIZE = 44;
    const PADDING = 30;
    const BOARD_PX = PADDING * 2 + CELL_SIZE * 8; // 382
    const STONE_RADIUS = 18;
    const STAR_RADIUS = 4;
    // Star points on a 9x9 board (0-indexed)
    const STAR_POINTS = [
        [
            2,
            2
        ],
        [
            2,
            6
        ],
        [
            4,
            4
        ],
        [
            6,
            2
        ],
        [
            6,
            6
        ]
    ];
    /**
	 * Render the 9x9 SVG board
	 */ const renderBoard = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            viewBox: `0 0 ${BOARD_PX} ${BOARD_PX}`,
            className: "atari-go-board",
            onClick: (e)=>{
                const target = e.target;
                if (target.hasAttribute('data-row')) {
                    const row = parseInt(target.getAttribute('data-row'), 10);
                    const col = parseInt(target.getAttribute('data-col'), 10);
                    handleClick(row, col);
                }
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: 0,
                    y: 0,
                    width: BOARD_PX,
                    height: BOARD_PX,
                    fill: "#dcb468",
                    rx: 6
                }),
                Array.from({
                    length: 9
                }, (_, i)=>{
                    const pos = PADDING + i * CELL_SIZE;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: PADDING,
                                y1: pos,
                                x2: PADDING + 8 * CELL_SIZE,
                                y2: pos,
                                stroke: "#7a5c2e",
                                strokeWidth: 1
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                x1: pos,
                                y1: PADDING,
                                x2: pos,
                                y2: PADDING + 8 * CELL_SIZE,
                                stroke: "#7a5c2e",
                                strokeWidth: 1
                            })
                        ]
                    }, `grid-${i}`);
                }),
                STAR_POINTS.map(([r, c])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: PADDING + c * CELL_SIZE,
                        cy: PADDING + r * CELL_SIZE,
                        r: STAR_RADIUS,
                        fill: "#7a5c2e",
                        pointerEvents: "none"
                    }, `star-${r}-${c}`)),
                Array.from({
                    length: 9
                }, (_, row)=>Array.from({
                        length: 9
                    }, (_, col)=>{
                        const index = coordsToIndex(row, col);
                        const stone = board[index];
                        const cx = PADDING + col * CELL_SIZE;
                        const cy = PADDING + row * CELL_SIZE;
                        const atari = stone ? isInAtari(board, index) : false;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            children: [
                                stone === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        atari && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: cx,
                                            cy: cy,
                                            r: STONE_RADIUS + 4,
                                            fill: "none",
                                            stroke: "#e53935",
                                            strokeWidth: 2.5,
                                            opacity: 0.85,
                                            pointerEvents: "none"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: cx,
                                            cy: cy,
                                            r: STONE_RADIUS,
                                            fill: "#111",
                                            stroke: "#000",
                                            strokeWidth: 1,
                                            pointerEvents: "none"
                                        })
                                    ]
                                }),
                                stone === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        atari && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: cx,
                                            cy: cy,
                                            r: STONE_RADIUS + 4,
                                            fill: "none",
                                            stroke: "#e53935",
                                            strokeWidth: 2.5,
                                            opacity: 0.85,
                                            pointerEvents: "none"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            cx: cx,
                                            cy: cy,
                                            r: STONE_RADIUS,
                                            fill: "#fff",
                                            stroke: "#333",
                                            strokeWidth: 1.5,
                                            pointerEvents: "none"
                                        })
                                    ]
                                }),
                                !stone && !winner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: cx,
                                    cy: cy,
                                    r: STONE_RADIUS,
                                    fill: "transparent",
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    "data-row": row,
                                    "data-col": col
                                })
                            ]
                        }, `cell-${row}-${col}`);
                    }))
            ]
        });
    };
    // ── Configuration screen ─────────────────────────────────────────────────
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Atari Go"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Configura\xe7\xe3o dos Jogadores"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador 1 (Pretas)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[1] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(1, 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Jogador 2 (Brancas)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'human'),
                                        children: "Humano"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes[2] === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange(2, 'computer'),
                                        children: "Computador"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Posi\xe7\xe3o Inicial"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${!useCrossCut ? 'selected' : ''}`,
                                        onClick: ()=>setUseCrossCut(false),
                                        children: "Tabuleiro Vazio"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${useCrossCut ? 'selected' : ''}`,
                                        onClick: ()=>setUseCrossCut(true),
                                        children: "Cruzamento"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Iniciar Jogo"
            })
        ]
    });
    // ── Game screen ──────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container atari-go-game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Atari Go"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            renderBoard(),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "Novo Jogo"
            })
        ]
    });
};
var $00886599104d87f2$export$2e2bcd8739ae039 = $00886599104d87f2$var$AtariGo;




var $acw62 = parcelRequire("acw62");
// Game of the Amazons Component
// Two players each have 4 amazons on a 10×10 board.
// On each turn a player moves one amazon (queen-like) then shoots an arrow
// (also queen-like) from its new position.  Arrow squares are permanently
// blocked.  A player loses when they have no valid move on their turn.
const $61840e079ced8044$var$BOARD_SIZE = 10;
// Initial board: null | 'white' | 'black' | 'arrow'
const $61840e079ced8044$var$createInitialBoard = ()=>{
    const board = Array($61840e079ced8044$var$BOARD_SIZE * $61840e079ced8044$var$BOARD_SIZE).fill(null);
    // White amazons: d1(9,3), g1(9,6), a4(6,0), j4(6,9)
    board[9 * $61840e079ced8044$var$BOARD_SIZE + 3] = 'white';
    board[9 * $61840e079ced8044$var$BOARD_SIZE + 6] = 'white';
    board[6 * $61840e079ced8044$var$BOARD_SIZE + 0] = 'white';
    board[6 * $61840e079ced8044$var$BOARD_SIZE + 9] = 'white';
    // Black amazons: d10(0,3), g10(0,6), a7(3,0), j7(3,9)
    board[0 * $61840e079ced8044$var$BOARD_SIZE + 3] = 'black';
    board[0 * $61840e079ced8044$var$BOARD_SIZE + 6] = 'black';
    board[3 * $61840e079ced8044$var$BOARD_SIZE + 0] = 'black';
    board[3 * $61840e079ced8044$var$BOARD_SIZE + 9] = 'black';
    return board;
};
/**
 * Returns all squares reachable from `from` via queen-like movement on `board`.
 * Treats `board[from]` as the occupant (not blocking outward rays).
 */ const $61840e079ced8044$var$getReachable = (from, board)=>{
    const row = Math.floor(from / $61840e079ced8044$var$BOARD_SIZE);
    const col = from % $61840e079ced8044$var$BOARD_SIZE;
    const dirs = [
        [
            -1,
            -1
        ],
        [
            -1,
            0
        ],
        [
            -1,
            1
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ],
        [
            1,
            -1
        ],
        [
            1,
            0
        ],
        [
            1,
            1
        ]
    ];
    const reachable = [];
    for (const [dr, dc] of dirs){
        let r = row + dr;
        let c = col + dc;
        while(r >= 0 && r < $61840e079ced8044$var$BOARD_SIZE && c >= 0 && c < $61840e079ced8044$var$BOARD_SIZE){
            const idx = r * $61840e079ced8044$var$BOARD_SIZE + c;
            if (board[idx] !== null) break;
            reachable.push(idx);
            r += dr;
            c += dc;
        }
    }
    return reachable;
};
/**
 * Returns true if `player` has at least one valid move on `board`.
 */ const $61840e079ced8044$var$hasValidMoves = (player, board)=>{
    for(let i = 0; i < board.length; i++){
        if (board[i] === player && $61840e079ced8044$var$getReachable(i, board).length > 0) return true;
    }
    return false;
};
/**
 * Collect all (amazonIdx, destIdx, arrowIdx) triples for `player` on `board`.
 */ const $61840e079ced8044$var$getAllMoves = (player, board)=>{
    const moves = [];
    for(let amazon = 0; amazon < board.length; amazon++){
        if (board[amazon] !== player) continue;
        const dests = $61840e079ced8044$var$getReachable(amazon, board);
        for (const dest of dests){
            // Temporarily apply the amazon move
            const tmpBoard = [
                ...board
            ];
            tmpBoard[amazon] = null;
            tmpBoard[dest] = player;
            const arrows = $61840e079ced8044$var$getReachable(dest, tmpBoard);
            for (const arrow of arrows)moves.push({
                amazon: amazon,
                dest: dest,
                arrow: arrow
            });
        }
    }
    return moves;
};
// ── Component ─────────────────────────────────────────────────────────────────
const $61840e079ced8044$var$Amazons = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        white: 'human',
        black: 'human'
    });
    const [board, setBoard] = (0, $acw62.useState)($61840e079ced8044$var$createInitialBoard);
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)('white');
    const [phase, setPhase] = (0, $acw62.useState)('move'); // 'move' | 'shoot'
    const [selectedAmazon, setSelectedAmazon] = (0, $acw62.useState)(null); // index
    const [movedAmazon, setMovedAmazon] = (0, $acw62.useState)(null); // new position after move
    const [winner, setWinner] = (0, $acw62.useState)(null);
    // ── Helpers ────────────────────────────────────────────────────────────────
    const resetGame = ()=>{
        setBoard($61840e079ced8044$var$createInitialBoard());
        setCurrentPlayer('white');
        setPhase('move');
        setSelectedAmazon(null);
        setMovedAmazon(null);
        setWinner(null);
        setGameStarted(false);
    };
    const startGame = ()=>setGameStarted(true);
    const handlePlayerTypeChange = (player, type)=>{
        setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    };
    // ── Human click handler ────────────────────────────────────────────────────
    const handleClick = (idx)=>{
        if (winner || !gameStarted) return;
        if (playerTypes[currentPlayer] !== 'human') return;
        if (phase === 'move') {
            if (selectedAmazon === null) // Select an amazon belonging to current player
            {
                if (board[idx] === currentPlayer && $61840e079ced8044$var$getReachable(idx, board).length > 0) setSelectedAmazon(idx);
            } else if (idx === selectedAmazon) // Deselect
            setSelectedAmazon(null);
            else {
                const validDests = $61840e079ced8044$var$getReachable(selectedAmazon, board);
                if (validDests.includes(idx)) {
                    // Move the amazon
                    const newBoard = [
                        ...board
                    ];
                    newBoard[selectedAmazon] = null;
                    newBoard[idx] = currentPlayer;
                    setBoard(newBoard);
                    setMovedAmazon(idx);
                    setSelectedAmazon(null);
                    setPhase('shoot');
                } else if (board[idx] === currentPlayer) // Select a different amazon
                {
                    if ($61840e079ced8044$var$getReachable(idx, board).length > 0) setSelectedAmazon(idx);
                }
            }
        } else {
            // phase === 'shoot'
            const validArrows = $61840e079ced8044$var$getReachable(movedAmazon, board);
            if (validArrows.includes(idx)) {
                const newBoard = [
                    ...board
                ];
                newBoard[idx] = 'arrow';
                setBoard(newBoard);
                const nextPlayer = currentPlayer === 'white' ? 'black' : 'white';
                if (!$61840e079ced8044$var$hasValidMoves(nextPlayer, newBoard)) setWinner(currentPlayer);
                else {
                    setCurrentPlayer(nextPlayer);
                    setPhase('move');
                    setMovedAmazon(null);
                }
            }
        }
    };
    // ── Computer player ────────────────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner) return;
        if (playerTypes[currentPlayer] !== 'computer') return;
        const timeoutId = setTimeout(()=>{
            const moves = $61840e079ced8044$var$getAllMoves(currentPlayer, board);
            if (moves.length === 0) {
                const nextPlayer = currentPlayer === 'white' ? 'black' : 'white';
                setWinner(nextPlayer);
                return;
            }
            const { amazon: amazon, dest: dest, arrow: arrow } = moves[Math.floor(Math.random() * moves.length)];
            const newBoard = [
                ...board
            ];
            newBoard[amazon] = null;
            newBoard[dest] = currentPlayer;
            newBoard[arrow] = 'arrow';
            setBoard(newBoard);
            const nextPlayer = currentPlayer === 'white' ? 'black' : 'white';
            if (!$61840e079ced8044$var$hasValidMoves(nextPlayer, newBoard)) setWinner(currentPlayer);
            else {
                setCurrentPlayer(nextPlayer);
                setPhase('move');
                setMovedAmazon(null);
            }
        }, 500);
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPlayer,
        gameStarted,
        winner,
        board,
        playerTypes
    ]);
    // ── Status message ─────────────────────────────────────────────────────────
    const getStatus = ()=>{
        if (winner) {
            const name = winner === 'white' ? 'White' : 'Black';
            return `Winner: ${name}!`;
        }
        const name = currentPlayer === 'white' ? 'White' : 'Black';
        if (phase === 'move') return `Current Turn: ${name} \u{2014} Select and move an amazon`;
        return `Current Turn: ${name} \u{2014} Shoot an arrow`;
    };
    // ── Configuration screen ───────────────────────────────────────────────────
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Amazons"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Player Configuration"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "White"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.white === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('white', 'human'),
                                        children: "Human"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.white === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('white', 'computer'),
                                        children: "Computer"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Black"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.black === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('black', 'human'),
                                        children: "Human"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.black === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('black', 'computer'),
                                        children: "Computer"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Start Game"
            })
        ]
    });
    // ── Compute highlights ─────────────────────────────────────────────────────
    const isHumanTurn = playerTypes[currentPlayer] === 'human';
    let validSet = new Set();
    if (!winner && isHumanTurn) {
        if (phase === 'move' && selectedAmazon !== null) $61840e079ced8044$var$getReachable(selectedAmazon, board).forEach((i)=>validSet.add(i));
        else if (phase === 'shoot' && movedAmazon !== null) $61840e079ced8044$var$getReachable(movedAmazon, board).forEach((i)=>validSet.add(i));
    }
    // ── Board rendering ────────────────────────────────────────────────────────
    const CELL = 100; // SVG units per cell
    const VIEWBOX = $61840e079ced8044$var$BOARD_SIZE * CELL;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Amazons"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: `0 0 ${VIEWBOX} ${VIEWBOX}`,
                className: "amazons-svg",
                children: board.map((cell, idx)=>{
                    const row = Math.floor(idx / $61840e079ced8044$var$BOARD_SIZE);
                    const col = idx % $61840e079ced8044$var$BOARD_SIZE;
                    const x = col * CELL;
                    const y = row * CELL;
                    const isLight = (row + col) % 2 === 0;
                    const isSelected = idx === selectedAmazon;
                    const isMovedAmazon = idx === movedAmazon;
                    const isValid = validSet.has(idx);
                    let squareFill;
                    if (isSelected || isMovedAmazon) squareFill = '#86efac'; // green highlight
                    else if (isValid) squareFill = '#fde68a'; // yellow hint
                    else if (isLight) squareFill = '#f0d9b5';
                    else squareFill = '#b58863';
                    const isClickable = !winner && isHumanTurn && (phase === 'move' && (selectedAmazon === null && cell === currentPlayer || selectedAmazon !== null && (isValid || cell === currentPlayer && idx !== selectedAmazon)) || phase === 'shoot' && isValid);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        onClick: ()=>handleClick(idx),
                        style: {
                            cursor: isClickable ? 'pointer' : 'default'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: x,
                                y: y,
                                width: CELL,
                                height: CELL,
                                fill: squareFill,
                                stroke: isSelected || isMovedAmazon ? '#16a34a' : '#8b7355',
                                strokeWidth: isSelected || isMovedAmazon ? 3 : 0.5
                            }),
                            cell === 'arrow' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: x + 25,
                                y: y + 25,
                                width: 50,
                                height: 50,
                                rx: 4,
                                fill: "#44403c"
                            }),
                            (cell === 'white' || cell === 'black') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: x + CELL / 2,
                                        cy: y + CELL / 2,
                                        r: 36,
                                        fill: cell === 'white' ? '#f8fafc' : '#1e293b',
                                        stroke: cell === 'white' ? '#64748b' : '#94a3b8',
                                        strokeWidth: 3
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                        x: x + CELL / 2,
                                        y: y + CELL / 2 + 9,
                                        textAnchor: "middle",
                                        fontSize: "30",
                                        fontWeight: "bold",
                                        fill: cell === 'white' ? '#334155' : '#e2e8f0',
                                        children: "\u265B"
                                    })
                                ]
                            }),
                            isValid && cell === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                cx: x + CELL / 2,
                                cy: y + CELL / 2,
                                r: 10,
                                fill: "rgba(0,0,0,0.2)"
                            })
                        ]
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "New Game"
            })
        ]
    });
};
var $61840e079ced8044$export$2e2bcd8739ae039 = $61840e079ced8044$var$Amazons;




var $acw62 = parcelRequire("acw62");
// Breakthrough Game Component
// Two players each have 16 pieces on an 8×8 board.
// White (Player 1) occupies rows 6–7 (bottom); Black (Player 2) occupies rows 0–1 (top).
// A piece may move one square straight forward or diagonally forward.
// Diagonal moves may capture an opponent piece; straight-forward moves only go to empty squares.
// A player wins by reaching the opponent's back row, capturing all opponent pieces,
// or leaving the opponent with no valid moves.
const $b2b53853da6eaef8$var$BOARD_SIZE = 8;
const $b2b53853da6eaef8$var$createInitialBoard = ()=>{
    const board = Array($b2b53853da6eaef8$var$BOARD_SIZE * $b2b53853da6eaef8$var$BOARD_SIZE).fill(null);
    for(let col = 0; col < $b2b53853da6eaef8$var$BOARD_SIZE; col++){
        board[0 * $b2b53853da6eaef8$var$BOARD_SIZE + col] = 'black'; // row 0
        board[1 * $b2b53853da6eaef8$var$BOARD_SIZE + col] = 'black'; // row 1
        board[6 * $b2b53853da6eaef8$var$BOARD_SIZE + col] = 'white'; // row 6
        board[7 * $b2b53853da6eaef8$var$BOARD_SIZE + col] = 'white'; // row 7
    }
    return board;
};
/**
 * Returns all valid destination indices for a piece at `from` on `board`.
 * White moves upward (decreasing row); Black moves downward (increasing row).
 * Straight-forward moves only reach empty squares.
 * Diagonal-forward moves reach empty squares OR opponent squares (capture).
 */ const $b2b53853da6eaef8$var$getValidMovesForPiece = (from, board)=>{
    const piece = board[from];
    if (!piece) return [];
    const row = Math.floor(from / $b2b53853da6eaef8$var$BOARD_SIZE);
    const col = from % $b2b53853da6eaef8$var$BOARD_SIZE;
    const opponent = piece === 'white' ? 'black' : 'white';
    // White moves up (dRow = -1); Black moves down (dRow = +1)
    const dRow = piece === 'white' ? -1 : 1;
    const moves = [];
    // Three forward directions: straight, diagonal-left, diagonal-right
    for (const dCol of [
        -1,
        0,
        1
    ]){
        const newRow = row + dRow;
        const newCol = col + dCol;
        if (newRow < 0 || newRow >= $b2b53853da6eaef8$var$BOARD_SIZE || newCol < 0 || newCol >= $b2b53853da6eaef8$var$BOARD_SIZE) continue;
        const target = board[newRow * $b2b53853da6eaef8$var$BOARD_SIZE + newCol];
        if (dCol === 0) // Straight forward: only to empty squares
        {
            if (target === null) moves.push(newRow * $b2b53853da6eaef8$var$BOARD_SIZE + newCol);
        } else // Diagonal: empty square or opponent piece (capture)
        if (target === null || target === opponent) moves.push(newRow * $b2b53853da6eaef8$var$BOARD_SIZE + newCol);
    }
    return moves;
};
/**
 * Returns true if `player` has at least one valid move on `board`.
 */ const $b2b53853da6eaef8$var$hasValidMoves = (player, board)=>{
    for(let i = 0; i < board.length; i++){
        if (board[i] === player && $b2b53853da6eaef8$var$getValidMovesForPiece(i, board).length > 0) return true;
    }
    return false;
};
/**
 * Collect all { from, to } moves for `player` on `board`.
 */ const $b2b53853da6eaef8$var$getAllMoves = (player, board)=>{
    const moves = [];
    for(let i = 0; i < board.length; i++){
        if (board[i] === player) for (const to of $b2b53853da6eaef8$var$getValidMovesForPiece(i, board))moves.push({
            from: i,
            to: to
        });
    }
    return moves;
};
/**
 * Check if `player` has won after moving a piece to `toIndex` on `board`.
 * Win conditions:
 *  - Reached opponent's back row
 *  - Opponent has no pieces remaining
 *  - Opponent has no valid moves
 */ const $b2b53853da6eaef8$var$checkWin = (player, toIndex, board)=>{
    const row = Math.floor(toIndex / $b2b53853da6eaef8$var$BOARD_SIZE);
    const opponent = player === 'white' ? 'black' : 'white';
    // Reached opponent's back row
    if (player === 'white' && row === 0) return true;
    if (player === 'black' && row === $b2b53853da6eaef8$var$BOARD_SIZE - 1) return true;
    // Opponent has no pieces
    if (!board.some((c)=>c === opponent)) return true;
    // Opponent has no valid moves
    if (!$b2b53853da6eaef8$var$hasValidMoves(opponent, board)) return true;
    return false;
};
// ── Component ─────────────────────────────────────────────────────────────────
const $b2b53853da6eaef8$var$Breakthrough = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        white: 'human',
        black: 'human'
    });
    const [board, setBoard] = (0, $acw62.useState)($b2b53853da6eaef8$var$createInitialBoard);
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)('white');
    const [selectedPiece, setSelectedPiece] = (0, $acw62.useState)(null); // index
    const [validMoveSet, setValidMoveSet] = (0, $acw62.useState)(new Set());
    const [winner, setWinner] = (0, $acw62.useState)(null);
    // ── Helpers ────────────────────────────────────────────────────────────────
    const resetGame = ()=>{
        setBoard($b2b53853da6eaef8$var$createInitialBoard());
        setCurrentPlayer('white');
        setSelectedPiece(null);
        setValidMoveSet(new Set());
        setWinner(null);
        setGameStarted(false);
    };
    const startGame = ()=>setGameStarted(true);
    const handlePlayerTypeChange = (player, type)=>{
        setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    };
    // ── Human click handler ────────────────────────────────────────────────────
    const handleClick = (idx)=>{
        if (winner || !gameStarted) return;
        if (playerTypes[currentPlayer] !== 'human') return;
        if (selectedPiece === null) // Select a piece belonging to the current player
        {
            if (board[idx] === currentPlayer) {
                const moves = $b2b53853da6eaef8$var$getValidMovesForPiece(idx, board);
                if (moves.length > 0) {
                    setSelectedPiece(idx);
                    setValidMoveSet(new Set(moves));
                }
            }
        } else if (idx === selectedPiece) {
            // Deselect
            setSelectedPiece(null);
            setValidMoveSet(new Set());
        } else if (validMoveSet.has(idx)) {
            // Perform move
            const newBoard = [
                ...board
            ];
            newBoard[idx] = currentPlayer;
            newBoard[selectedPiece] = null;
            setBoard(newBoard);
            setSelectedPiece(null);
            setValidMoveSet(new Set());
            if ($b2b53853da6eaef8$var$checkWin(currentPlayer, idx, newBoard)) setWinner(currentPlayer);
            else setCurrentPlayer(currentPlayer === 'white' ? 'black' : 'white');
        } else if (board[idx] === currentPlayer) {
            // Switch selection to another own piece
            const moves = $b2b53853da6eaef8$var$getValidMovesForPiece(idx, board);
            if (moves.length > 0) {
                setSelectedPiece(idx);
                setValidMoveSet(new Set(moves));
            }
        }
    };
    // ── Computer player ────────────────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner) return;
        if (playerTypes[currentPlayer] !== 'computer') return;
        const timeoutId = setTimeout(()=>{
            const moves = $b2b53853da6eaef8$var$getAllMoves(currentPlayer, board);
            if (moves.length === 0) {
                setWinner(currentPlayer === 'white' ? 'black' : 'white');
                return;
            }
            const { from: from, to: to } = moves[Math.floor(Math.random() * moves.length)];
            const newBoard = [
                ...board
            ];
            newBoard[to] = currentPlayer;
            newBoard[from] = null;
            setBoard(newBoard);
            if ($b2b53853da6eaef8$var$checkWin(currentPlayer, to, newBoard)) setWinner(currentPlayer);
            else setCurrentPlayer(currentPlayer === 'white' ? 'black' : 'white');
        }, 500);
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPlayer,
        gameStarted,
        winner,
        board,
        playerTypes
    ]);
    // ── Status message ─────────────────────────────────────────────────────────
    const getStatus = ()=>{
        if (winner) {
            const name = winner === 'white' ? 'White' : 'Black';
            return `Winner: ${name}!`;
        }
        const name = currentPlayer === 'white' ? 'White' : 'Black';
        return `Current Turn: ${name}`;
    };
    // ── Configuration screen ───────────────────────────────────────────────────
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Breakthrough"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Player Configuration"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "White (moves first)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.white === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('white', 'human'),
                                        children: "Human"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.white === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('white', 'computer'),
                                        children: "Computer"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Black"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.black === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('black', 'human'),
                                        children: "Human"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.black === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('black', 'computer'),
                                        children: "Computer"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Start Game"
            })
        ]
    });
    // ── Board rendering ────────────────────────────────────────────────────────
    const CELL = 100; // SVG units per cell
    const VIEWBOX = $b2b53853da6eaef8$var$BOARD_SIZE * CELL;
    const isHumanTurn = playerTypes[currentPlayer] === 'human';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Breakthrough"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: `0 0 ${VIEWBOX} ${VIEWBOX}`,
                className: "breakthrough-svg",
                children: board.map((cell, idx)=>{
                    const row = Math.floor(idx / $b2b53853da6eaef8$var$BOARD_SIZE);
                    const col = idx % $b2b53853da6eaef8$var$BOARD_SIZE;
                    const x = col * CELL;
                    const y = row * CELL;
                    const isLight = (row + col) % 2 === 0;
                    const isSelected = idx === selectedPiece;
                    const isValid = validMoveSet.has(idx);
                    let squareFill;
                    if (isSelected) squareFill = '#86efac'; // green highlight for selected piece
                    else if (isValid) squareFill = '#fde68a'; // yellow hint for valid destinations
                    else if (isLight) squareFill = '#f0d9b5';
                    else squareFill = '#b58863';
                    const isClickable = !winner && isHumanTurn && (selectedPiece === null && cell === currentPlayer || selectedPiece !== null && (isValid || cell === currentPlayer && idx !== selectedPiece));
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        onClick: ()=>handleClick(idx),
                        style: {
                            cursor: isClickable ? 'pointer' : 'default'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                x: x,
                                y: y,
                                width: CELL,
                                height: CELL,
                                fill: squareFill,
                                stroke: isSelected ? '#16a34a' : '#8b7355',
                                strokeWidth: isSelected ? 3 : 0.5
                            }),
                            (cell === 'white' || cell === 'black') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                cx: x + CELL / 2,
                                cy: y + CELL / 2,
                                r: 36,
                                fill: cell === 'white' ? '#f8fafc' : '#1e293b',
                                stroke: cell === 'white' ? '#64748b' : '#94a3b8',
                                strokeWidth: 3
                            }),
                            isValid && cell === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                cx: x + CELL / 2,
                                cy: y + CELL / 2,
                                r: 10,
                                fill: "rgba(0,0,0,0.2)"
                            })
                        ]
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "New Game"
            })
        ]
    });
};
var $b2b53853da6eaef8$export$2e2bcd8739ae039 = $b2b53853da6eaef8$var$Breakthrough;




var $acw62 = parcelRequire("acw62");
// Aboyne Game Component
// ─── Rules ────────────────────────────────────────────────────────────────────
// Board      : Hexagonal board with 5 cells per side (9 rows: 5,6,7,8,9,8,7,6,5),
//              61 cells total.
// Goal cell  : The marked tip on the OPPOSITE side — White's goal is the right tip
//              of row 4 (col 8); Black's goal is the left tip of row 4 (col 0).
// Setup      : White pieces on the left edge of each row; Black pieces on the right
//              edge.  In the middle row (row 4) the tips are goal cells so pieces
//              sit at col 1 (White) and col 7 (Black).
// Blocked    : A stone is blocked when at least one of its neighbours holds an
//              enemy piece.  Blocked stones cannot move.
// Turn       : Move one non-blocked stone:
//              - STEP  — move to an adjacent empty cell.
//              - JUMP  — leap over a consecutive line of friendly stones and land
//                        on the next cell.  If that cell holds an enemy stone it
//                        is captured (removed).
//              A stone may NOT enter the opponent's goal cell.
// Win        : Move a stone onto your own goal cell, OR stalemate the opponent
//              (all their non-blocked stones have no legal destination).
// ─────────────────────────────────────────────────────────────────────────────
const $058a925513e726f9$var$ROW_WIDTHS = [
    5,
    6,
    7,
    8,
    9,
    8,
    7,
    6,
    5
];
const $058a925513e726f9$var$NUM_ROWS = 9;
const $058a925513e726f9$var$N = 61;
// ROW_OFFSETS[r] = flat index of the first cell in row r
// = [0, 5, 11, 18, 26, 35, 43, 50, 56]
const $058a925513e726f9$var$ROW_OFFSETS = (()=>{
    const offs = [
        0
    ];
    for(let r = 0; r < $058a925513e726f9$var$NUM_ROWS - 1; r++)offs.push(offs[r] + $058a925513e726f9$var$ROW_WIDTHS[r]);
    return offs;
})();
// ── Coordinate helpers ────────────────────────────────────────────────────────
const $058a925513e726f9$var$toIdx = (row, col)=>$058a925513e726f9$var$ROW_OFFSETS[row] + col;
const $058a925513e726f9$var$fromIdx = (i)=>{
    let row = 0;
    while(row < $058a925513e726f9$var$NUM_ROWS - 1 && $058a925513e726f9$var$ROW_OFFSETS[row + 1] <= i)row++;
    return {
        row: row,
        col: i - $058a925513e726f9$var$ROW_OFFSETS[row]
    };
};
const $058a925513e726f9$var$inBounds = (row, col)=>row >= 0 && row < $058a925513e726f9$var$NUM_ROWS && col >= 0 && col < $058a925513e726f9$var$ROW_WIDTHS[row];
/**
 * Convert (row, col) offset coordinates to axial (q, r) coordinates.
 * The board centre (row 4) is (q=0, r=0).
 * q_min for row r equals max(-4, -r).
 */ const $058a925513e726f9$var$toAxial = (row, col)=>({
        q: Math.max(-4, -row) + col,
        r: row - 4
    });
/** Convert axial (q, r) back to (row, col). Returns {row:-1,col:-1} if invalid. */ const $058a925513e726f9$var$fromAxial = (q, r)=>{
    const row = r + 4;
    if (row < 0 || row >= $058a925513e726f9$var$NUM_ROWS) return {
        row: -1,
        col: -1
    };
    const col = q - Math.max(-4, -row);
    return {
        row: row,
        col: col
    };
};
// Six hex directions in axial coordinates (pointy-top hexagons)
const $058a925513e726f9$var$HEX_DIRS = [
    {
        dq: 1,
        dr: 0
    },
    {
        dq: -1,
        dr: 0
    },
    {
        dq: 0,
        dr: 1
    },
    {
        dq: 0,
        dr: -1
    },
    {
        dq: 1,
        dr: -1
    },
    {
        dq: -1,
        dr: 1
    }
];
// ── Goal cells & initial board ────────────────────────────────────────────────
// White starts LEFT → White's goal is the rightmost tip of row 4 (col 8).
// Black starts RIGHT → Black's goal is the leftmost tip of row 4 (col 0).
const $058a925513e726f9$var$WHITE_GOAL = $058a925513e726f9$var$toIdx(4, $058a925513e726f9$var$ROW_WIDTHS[4] - 1); // (row 4, col 8)
const $058a925513e726f9$var$BLACK_GOAL = $058a925513e726f9$var$toIdx(4, 0); // (row 4, col 0)
const $058a925513e726f9$var$goalOf = (p)=>p === 'white' ? $058a925513e726f9$var$WHITE_GOAL : $058a925513e726f9$var$BLACK_GOAL;
const $058a925513e726f9$var$oppGoalOf = (p)=>p === 'white' ? $058a925513e726f9$var$BLACK_GOAL : $058a925513e726f9$var$WHITE_GOAL;
const $058a925513e726f9$var$createInitialBoard = ()=>{
    const b = Array($058a925513e726f9$var$N).fill(null);
    for(let row = 0; row < $058a925513e726f9$var$NUM_ROWS; row++)if (row === 4) {
        // Goal cells (col 0 and col 8) stay empty; pieces at col 1 and col 7
        b[$058a925513e726f9$var$toIdx(4, 1)] = 'white';
        b[$058a925513e726f9$var$toIdx(4, $058a925513e726f9$var$ROW_WIDTHS[4] - 2)] = 'black';
    } else {
        b[$058a925513e726f9$var$toIdx(row, 0)] = 'white';
        b[$058a925513e726f9$var$toIdx(row, $058a925513e726f9$var$ROW_WIDTHS[row] - 1)] = 'black';
    }
    return b;
};
// ── Game logic ────────────────────────────────────────────────────────────────
const $058a925513e726f9$var$opp = (p)=>p === 'white' ? 'black' : 'white';
/**
 * Returns true when the piece at `idx` (belonging to `player`) is blocked.
 * A stone is blocked when at least one neighbour holds an enemy piece.
 */ const $058a925513e726f9$var$isBlocked = (idx, board, player)=>{
    const { row: row, col: col } = $058a925513e726f9$var$fromIdx(idx);
    const { q: q, r: r } = $058a925513e726f9$var$toAxial(row, col);
    const enemy = $058a925513e726f9$var$opp(player);
    for (const { dq: dq, dr: dr } of $058a925513e726f9$var$HEX_DIRS){
        const nb = $058a925513e726f9$var$fromAxial(q + dq, r + dr);
        if (!$058a925513e726f9$var$inBounds(nb.row, nb.col)) continue;
        if (board[$058a925513e726f9$var$toIdx(nb.row, nb.col)] === enemy) return true;
    }
    return false;
};
/**
 * Returns valid destinations for the non-blocked piece at `idx`.
 * Each entry is { to: idx, capture: idx | null }.
 *
 * - STEP : adjacent empty cell (not opponent's goal).
 * - JUMP : leap over a consecutive run of friendly pieces; land on the next
 *          cell.  If that cell holds an enemy, it is captured.
 *          Cannot land on the opponent's goal cell.
 */ const $058a925513e726f9$var$getPieceMoves = (idx, board, player)=>{
    const { row: row, col: col } = $058a925513e726f9$var$fromIdx(idx);
    const { q: q, r: r } = $058a925513e726f9$var$toAxial(row, col);
    const enemy = $058a925513e726f9$var$opp(player);
    const oppGoal = $058a925513e726f9$var$oppGoalOf(player);
    const dests = [];
    for (const { dq: dq, dr: dr } of $058a925513e726f9$var$HEX_DIRS){
        // Count consecutive friendly pieces in this direction (board has ≤ 9 cells per row).
        let k = 0;
        while(k < $058a925513e726f9$var$NUM_ROWS){
            const nb = $058a925513e726f9$var$fromAxial(q + dq * (k + 1), r + dr * (k + 1));
            if (!$058a925513e726f9$var$inBounds(nb.row, nb.col)) break;
            if (board[$058a925513e726f9$var$toIdx(nb.row, nb.col)] !== player) break;
            k++;
        }
        // Landing cell is k+1 steps away.
        const land = $058a925513e726f9$var$fromAxial(q + dq * (k + 1), r + dr * (k + 1));
        if (!$058a925513e726f9$var$inBounds(land.row, land.col)) continue;
        const landIdx = $058a925513e726f9$var$toIdx(land.row, land.col);
        if (landIdx === oppGoal) continue; // cannot enter opponent's goal
        if (k === 0) // Step: adjacent cell must be empty.
        {
            if (board[landIdx] === null) dests.push({
                to: landIdx,
                capture: null
            });
        } else {
            // Jump over k friendly pieces; land on empty cell or capture enemy.
            if (board[landIdx] === null) dests.push({
                to: landIdx,
                capture: null
            });
            else if (board[landIdx] === enemy) dests.push({
                to: landIdx,
                capture: landIdx
            });
        }
    }
    return dests;
};
/** All legal moves for `player` on `board` — { from, to, capture }. */ const $058a925513e726f9$var$getAllMoves = (player, board)=>{
    const moves = [];
    for(let i = 0; i < $058a925513e726f9$var$N; i++){
        if (board[i] !== player) continue;
        if ($058a925513e726f9$var$isBlocked(i, board, player)) continue;
        for (const dest of $058a925513e726f9$var$getPieceMoves(i, board, player))moves.push({
            from: i,
            ...dest
        });
    }
    return moves;
};
// ── Component ─────────────────────────────────────────────────────────────────
const $058a925513e726f9$var$Aboyne = ()=>{
    const [gameStarted, setGameStarted] = (0, $acw62.useState)(false);
    const [playerTypes, setPlayerTypes] = (0, $acw62.useState)({
        white: 'human',
        black: 'human'
    });
    const [board, setBoard] = (0, $acw62.useState)($058a925513e726f9$var$createInitialBoard);
    const [currentPlayer, setCurrentPlayer] = (0, $acw62.useState)('white');
    const [selectedPiece, setSelectedPiece] = (0, $acw62.useState)(null);
    const [validMovesMap, setValidMovesMap] = (0, $acw62.useState)(new Map()); // to → capture
    const [winner, setWinner] = (0, $acw62.useState)(null);
    // ── Helpers ───────────────────────────────────────────────────────────────
    const selectPiece = (idx)=>{
        const moves = $058a925513e726f9$var$getPieceMoves(idx, board, currentPlayer);
        setSelectedPiece(idx);
        setValidMovesMap(new Map(moves.map(({ to: to, capture: capture })=>[
                to,
                capture
            ])));
    };
    const resetGame = ()=>{
        setBoard($058a925513e726f9$var$createInitialBoard());
        setCurrentPlayer('white');
        setSelectedPiece(null);
        setValidMovesMap(new Map());
        setWinner(null);
        setGameStarted(false);
    };
    const startGame = ()=>setGameStarted(true);
    const handlePlayerTypeChange = (player, type)=>setPlayerTypes((prev)=>({
                ...prev,
                [player]: type
            }));
    /**
   * Apply a completed move, then check for win (goal reached or stalemate).
   * `movedTo` is the destination index of the just-moved piece.
   */ const applyAction = (newBoard, movedTo, player)=>{
        if (movedTo === $058a925513e726f9$var$goalOf(player)) setWinner(player);
        else {
            const next = $058a925513e726f9$var$opp(player);
            if ($058a925513e726f9$var$getAllMoves(next, newBoard).length === 0) setWinner(player); // stalemate — current player wins
            else setCurrentPlayer(next);
        }
        setSelectedPiece(null);
        setValidMovesMap(new Map());
    };
    // ── Human click handler ───────────────────────────────────────────────────
    const handleClick = (idx)=>{
        if (winner || !gameStarted) return;
        if (playerTypes[currentPlayer] !== 'human') return;
        if (selectedPiece !== null) {
            if (idx === selectedPiece) {
                // Deselect
                setSelectedPiece(null);
                setValidMovesMap(new Map());
                return;
            }
            if (validMovesMap.has(idx)) {
                // Execute move (step or jump, optionally with capture)
                const capture = validMovesMap.get(idx);
                const newBoard = [
                    ...board
                ];
                newBoard[idx] = currentPlayer;
                newBoard[selectedPiece] = null;
                if (capture !== null) newBoard[capture] = null;
                setBoard(newBoard);
                applyAction(newBoard, idx, currentPlayer);
                return;
            }
            if (board[idx] === currentPlayer && !$058a925513e726f9$var$isBlocked(idx, board, currentPlayer)) {
                // Switch selection to another own non-blocked piece
                const moves = $058a925513e726f9$var$getPieceMoves(idx, board, currentPlayer);
                if (moves.length > 0) {
                    selectPiece(idx);
                    return;
                }
            }
            // Click elsewhere → deselect
            setSelectedPiece(null);
            setValidMovesMap(new Map());
            return;
        }
        // No piece selected: click own non-blocked piece to select it
        if (board[idx] === currentPlayer && !$058a925513e726f9$var$isBlocked(idx, board, currentPlayer)) {
            const moves = $058a925513e726f9$var$getPieceMoves(idx, board, currentPlayer);
            if (moves.length > 0) selectPiece(idx);
        }
    };
    // ── Computer player ───────────────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!gameStarted || winner) return;
        if (playerTypes[currentPlayer] !== 'computer') return;
        const id = setTimeout(()=>{
            const moves = $058a925513e726f9$var$getAllMoves(currentPlayer, board);
            if (moves.length === 0) {
                setWinner($058a925513e726f9$var$opp(currentPlayer));
                return;
            }
            const { from: from, to: to, capture: capture } = moves[Math.floor(Math.random() * moves.length)];
            const newBoard = [
                ...board
            ];
            newBoard[to] = currentPlayer;
            newBoard[from] = null;
            if (capture !== null) newBoard[capture] = null;
            setBoard(newBoard);
            applyAction(newBoard, to, currentPlayer);
        }, 500);
        return ()=>clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPlayer,
        gameStarted,
        winner,
        board,
        playerTypes
    ]);
    // ── Status ────────────────────────────────────────────────────────────────
    const getStatus = ()=>{
        if (winner) {
            const name = winner === 'white' ? 'White' : 'Black';
            return `${name} wins!`;
        }
        return `Current Turn: ${currentPlayer === 'white' ? 'White' : 'Black'}`;
    };
    // ── Configuration screen ──────────────────────────────────────────────────
    if (!gameStarted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Aboyne"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Player Configuration"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "player-config",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "White (moves first)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.white === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('white', 'human'),
                                        children: "Human"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.white === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('white', 'computer'),
                                        children: "Computer"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "player-config-item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: "Black"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "player-type-selector",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.black === 'human' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('black', 'human'),
                                        children: "Human"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: `player-type-button ${playerTypes.black === 'computer' ? 'selected' : ''}`,
                                        onClick: ()=>handlePlayerTypeChange('black', 'computer'),
                                        children: "Computer"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: startGame,
                children: "Start Game"
            })
        ]
    });
    // ── SVG board rendering ───────────────────────────────────────────────────
    // Pointy-top hexagons, axial coordinates.
    // The widest row (row 4) has 9 cells; each row is centred around the same x.
    const R = 40; // circumradius (centre → vertex)
    const W_HEX = Math.sqrt(3) * R; // horizontal cell spacing ≈ 69.28
    const V_STEP = 1.5 * R; // vertical row spacing = 60
    const PAD = 12; // padding around the board
    const SVG_W = Math.round(2 * PAD + 9 * W_HEX); // ≈ 648
    const SVG_H = Math.round(2 * PAD + 2 * R + 8 * V_STEP); //  = 584
    const CENTER_X = PAD + 4.5 * W_HEX; // horizontal centre of the board
    const CENTER_Y = PAD + R + 4 * V_STEP; // vertical centre (row 4)
    /** Pixel centre of cell (row, col) derived from axial coordinates. */ const cellCenter = (row, col)=>{
        const { q: q, r: r } = $058a925513e726f9$var$toAxial(row, col);
        return {
            cx: CENTER_X + W_HEX * (q + r * 0.5),
            cy: CENTER_Y + V_STEP * r
        };
    };
    /** SVG polygon points for a pointy-top hexagon centred at (cx, cy). */ const hexPoints = (cx, cy, r)=>Array.from({
            length: 6
        }, (_, k)=>{
            const a = Math.PI / 3 * k - Math.PI / 2;
            return `${cx + r * Math.cos(a)},${cy + r * Math.sin(a)}`;
        }).join(' ');
    const isHumanTurn = playerTypes[currentPlayer] === 'human';
    // Pre-compute which of the current player's pieces are selectable.
    const moveableSet = new Set();
    if (!winner && isHumanTurn && selectedPiece === null) for(let i = 0; i < $058a925513e726f9$var$N; i++){
        if (board[i] !== currentPlayer) continue;
        if (!$058a925513e726f9$var$isBlocked(i, board, currentPlayer) && $058a925513e726f9$var$getPieceMoves(i, board, currentPlayer).length > 0) moveableSet.add(i);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Aboyne"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `game-status ${winner ? 'winner' : ''}`,
                children: getStatus()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                viewBox: `0 0 ${SVG_W} ${SVG_H}`,
                className: "aboyne-svg",
                children: board.map((cell, idx)=>{
                    const { row: row, col: col } = $058a925513e726f9$var$fromIdx(idx);
                    const { cx: cx, cy: cy } = cellCenter(row, col);
                    const isSelected = idx === selectedPiece;
                    const isValid = validMovesMap.has(idx);
                    const isWhiteGoal = idx === $058a925513e726f9$var$WHITE_GOAL;
                    const isBlackGoal = idx === $058a925513e726f9$var$BLACK_GOAL;
                    let cellFill = '#c8a26e';
                    if (isSelected) cellFill = '#86efac';
                    else if (isValid) cellFill = '#fde68a';
                    else if (isWhiteGoal) cellFill = '#bfdbfe';
                    else if (isBlackGoal) cellFill = '#fecaca';
                    const clickable = !winner && isHumanTurn && (selectedPiece === null ? moveableSet.has(idx) : isValid || board[idx] === currentPlayer && moveableSet.has(idx));
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        onClick: ()=>handleClick(idx),
                        style: {
                            cursor: clickable ? 'pointer' : 'default'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                                points: hexPoints(cx, cy, R - 1.5),
                                fill: cellFill,
                                stroke: "#7a5534",
                                strokeWidth: isSelected ? 3 : 1.5
                            }),
                            (isWhiteGoal || isBlackGoal) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                                points: hexPoints(cx, cy, R * 0.55),
                                fill: "none",
                                stroke: isWhiteGoal ? '#2563eb' : '#dc2626',
                                strokeWidth: 2,
                                strokeDasharray: "4,3"
                            }),
                            cell === 'white' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                cx: cx,
                                cy: cy,
                                r: R * 0.52,
                                fill: "#f8fafc",
                                stroke: "#64748b",
                                strokeWidth: 2.5
                            }),
                            cell === 'black' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                cx: cx,
                                cy: cy,
                                r: R * 0.52,
                                fill: "#1e293b",
                                stroke: "#94a3b8",
                                strokeWidth: 2.5
                            }),
                            isValid && cell === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                cx: cx,
                                cy: cy,
                                r: 7,
                                fill: "rgba(0,0,0,0.25)"
                            })
                        ]
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "new-game-button",
                onClick: resetGame,
                children: "New Game"
            })
        ]
    });
};
var $058a925513e726f9$export$2e2bcd8739ae039 = $058a925513e726f9$var$Aboyne;




var $acw62 = parcelRequire("acw62");
// Difficulty levels. The `max` value bounds both the operands and the result
// (for additions a + b ≤ max; for subtractions a ≤ max with 0 ≤ b ≤ a so the
// result is never negative).
const $6b5f0c1a730bb466$var$LEVELS = [
    {
        id: 1,
        title: "N\xedvel 1",
        description: "At\xe9 20",
        max: 20
    },
    {
        id: 2,
        title: "N\xedvel 2",
        description: "At\xe9 100",
        max: 100
    },
    {
        id: 3,
        title: "N\xedvel 3",
        description: "At\xe9 500",
        max: 500
    },
    {
        id: 4,
        title: "N\xedvel 4",
        description: "At\xe9 1000",
        max: 1000
    }
];
const $6b5f0c1a730bb466$var$generateQuestion = (max)=>{
    const isAddition = Math.random() < 0.5;
    if (isAddition) {
        // a + b ≤ max, both ≥ 0
        const a = Math.floor(Math.random() * (max + 1));
        const b = Math.floor(Math.random() * (max - a + 1));
        return {
            a: a,
            b: b,
            op: '+',
            answer: a + b
        };
    }
    // a ≤ max, 0 ≤ b ≤ a so the result stays non-negative
    const a = Math.floor(Math.random() * (max + 1));
    const b = Math.floor(Math.random() * (a + 1));
    return {
        a: a,
        b: b,
        op: "\u2212",
        answer: a - b
    };
};
const $6b5f0c1a730bb466$var$AdditionsSubtractions = ()=>{
    const [level, setLevel] = (0, $acw62.useState)(null);
    const [question, setQuestion] = (0, $acw62.useState)(null);
    const [userAnswer, setUserAnswer] = (0, $acw62.useState)('');
    const [feedback, setFeedback] = (0, $acw62.useState)(null); // null | 'correct' | 'incorrect'
    const [score, setScore] = (0, $acw62.useState)({
        correct: 0,
        total: 0
    });
    const inputRef = (0, $acw62.useRef)(null);
    const nextButtonRef = (0, $acw62.useRef)(null);
    // Move focus to whichever element accepts the next keypress: the input
    // while the user is entering an answer, and the "Próxima" button once
    // feedback is shown (so pressing Enter advances to the next question on
    // both correct and incorrect responses — the input is disabled while
    // feedback is up and so doesn't receive key events itself).
    (0, $acw62.useEffect)(()=>{
        if (feedback === null && question !== null && inputRef.current) inputRef.current.focus();
        else if (feedback !== null && nextButtonRef.current) nextButtonRef.current.focus();
    }, [
        question,
        feedback
    ]);
    // Auto-advance after a correct answer so the activity stays in flow.
    (0, $acw62.useEffect)(()=>{
        if (feedback !== 'correct') return;
        const timeoutId = setTimeout(()=>nextQuestion(), 900);
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        feedback
    ]);
    const startLevel = (selected)=>{
        setLevel(selected);
        setQuestion($6b5f0c1a730bb466$var$generateQuestion(selected.max));
        setUserAnswer('');
        setFeedback(null);
        setScore({
            correct: 0,
            total: 0
        });
    };
    const checkAnswer = ()=>{
        if (feedback !== null || question === null) return;
        const trimmed = userAnswer.trim();
        if (trimmed === '') return;
        const parsed = Number(trimmed);
        if (!Number.isInteger(parsed)) return;
        const isCorrect = parsed === question.answer;
        setFeedback(isCorrect ? 'correct' : 'incorrect');
        setScore((s)=>({
                correct: s.correct + (isCorrect ? 1 : 0),
                total: s.total + 1
            }));
    };
    const nextQuestion = ()=>{
        setQuestion($6b5f0c1a730bb466$var$generateQuestion(level.max));
        setUserAnswer('');
        setFeedback(null);
    };
    const changeLevel = ()=>{
        setLevel(null);
        setQuestion(null);
        setUserAnswer('');
        setFeedback(null);
        setScore({
            correct: 0,
            total: 0
        });
    };
    const handleKeyDown = (e)=>{
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (feedback === 'incorrect') nextQuestion();
        else if (feedback === null) checkAnswer();
    };
    // Level selection screen — shown before any question is asked.
    if (level === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Adi\xe7\xf5es e Subtra\xe7\xf5es"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Escolhe o n\xedvel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "game-menu",
                children: $6b5f0c1a730bb466$var$LEVELS.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "menu-button",
                        onClick: ()=>startLevel(l),
                        children: [
                            l.title,
                            " \u2014 ",
                            l.description
                        ]
                    }, l.id))
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Adi\xe7\xf5es e Subtra\xe7\xf5es"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "game-status",
                children: [
                    level.title,
                    " (",
                    level.description,
                    ") \xb7 Pontua\xe7\xe3o: ",
                    score.correct,
                    " / ",
                    score.total
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "math-equation",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "math-operand",
                        children: question.a
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "math-operator",
                        children: question.op
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "math-operand",
                        children: question.b
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "math-operator",
                        children: "="
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        ref: inputRef,
                        type: "text",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        className: `math-answer-input ${feedback || ''}`,
                        value: userAnswer,
                        onChange: (e)=>setUserAnswer(e.target.value.replace(/[^0-9]/g, '')),
                        onKeyDown: handleKeyDown,
                        disabled: feedback !== null,
                        "aria-label": "Resposta"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `math-feedback ${feedback || ''}`,
                children: [
                    feedback === 'correct' && 'Correto!',
                    feedback === 'incorrect' && `Errado. ${question.a} ${question.op} ${question.b} = ${question.answer}.`
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "game-buttons",
                children: [
                    feedback === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "new-game-button",
                        onClick: checkAnswer,
                        children: "Verificar"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        ref: nextButtonRef,
                        className: "new-game-button",
                        onClick: nextQuestion,
                        children: "Pr\xf3xima"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "new-game-button",
                        onClick: changeLevel,
                        children: "Mudar N\xedvel"
                    })
                ]
            })
        ]
    });
};
var $6b5f0c1a730bb466$export$2e2bcd8739ae039 = $6b5f0c1a730bb466$var$AdditionsSubtractions;




var $acw62 = parcelRequire("acw62");
// Same difficulty scale as Adições e Subtrações.
const $f087fb7fe16aef3c$var$LEVELS = [
    {
        id: 1,
        title: "N\xedvel 1",
        description: "At\xe9 20",
        max: 20
    },
    {
        id: 2,
        title: "N\xedvel 2",
        description: "At\xe9 100",
        max: 100
    },
    {
        id: 3,
        title: "N\xedvel 3",
        description: "At\xe9 500",
        max: 500
    },
    {
        id: 4,
        title: "N\xedvel 4",
        description: "At\xe9 1000",
        max: 1000
    }
];
// Generate an equation with one of the operands hidden. The result is always
// shown — the user works backwards to recover the missing number.
//
// Returns: { a, b, op, result, missing: 'a' | 'b', answer }
const $f087fb7fe16aef3c$var$generateQuestion = (max)=>{
    const isAddition = Math.random() < 0.5;
    let a, b, result;
    if (isAddition) {
        a = Math.floor(Math.random() * (max + 1));
        b = Math.floor(Math.random() * (max - a + 1));
        result = a + b;
    } else {
        a = Math.floor(Math.random() * (max + 1));
        b = Math.floor(Math.random() * (a + 1));
        result = a - b;
    }
    const op = isAddition ? '+' : "\u2212";
    const missing = Math.random() < 0.5 ? 'a' : 'b';
    const answer = missing === 'a' ? a : b;
    return {
        a: a,
        b: b,
        op: op,
        result: result,
        missing: missing,
        answer: answer
    };
};
const $f087fb7fe16aef3c$var$MissingOperand = ()=>{
    const [level, setLevel] = (0, $acw62.useState)(null);
    const [question, setQuestion] = (0, $acw62.useState)(null);
    const [userAnswer, setUserAnswer] = (0, $acw62.useState)('');
    const [feedback, setFeedback] = (0, $acw62.useState)(null); // null | 'correct' | 'incorrect'
    const [score, setScore] = (0, $acw62.useState)({
        correct: 0,
        total: 0
    });
    const inputRef = (0, $acw62.useRef)(null);
    const nextButtonRef = (0, $acw62.useRef)(null);
    // Focus the input while the user is entering an answer; once feedback is
    // shown the input is disabled (and so swallows key events), so move focus
    // to "Próxima" instead — pressing Enter then advances to the next question
    // on both correct and incorrect responses.
    (0, $acw62.useEffect)(()=>{
        if (feedback === null && question !== null && inputRef.current) inputRef.current.focus();
        else if (feedback !== null && nextButtonRef.current) nextButtonRef.current.focus();
    }, [
        question,
        feedback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (feedback !== 'correct') return;
        const timeoutId = setTimeout(()=>nextQuestion(), 900);
        return ()=>clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        feedback
    ]);
    const startLevel = (selected)=>{
        setLevel(selected);
        setQuestion($f087fb7fe16aef3c$var$generateQuestion(selected.max));
        setUserAnswer('');
        setFeedback(null);
        setScore({
            correct: 0,
            total: 0
        });
    };
    const checkAnswer = ()=>{
        if (feedback !== null || question === null) return;
        const trimmed = userAnswer.trim();
        if (trimmed === '') return;
        const parsed = Number(trimmed);
        if (!Number.isInteger(parsed)) return;
        const isCorrect = parsed === question.answer;
        setFeedback(isCorrect ? 'correct' : 'incorrect');
        setScore((s)=>({
                correct: s.correct + (isCorrect ? 1 : 0),
                total: s.total + 1
            }));
    };
    const nextQuestion = ()=>{
        setQuestion($f087fb7fe16aef3c$var$generateQuestion(level.max));
        setUserAnswer('');
        setFeedback(null);
    };
    const changeLevel = ()=>{
        setLevel(null);
        setQuestion(null);
        setUserAnswer('');
        setFeedback(null);
        setScore({
            correct: 0,
            total: 0
        });
    };
    const handleKeyDown = (e)=>{
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (feedback === 'incorrect') nextQuestion();
        else if (feedback === null) checkAnswer();
    };
    if (level === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "N\xfamero em Falta"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Escolhe o n\xedvel"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "game-menu",
                children: $f087fb7fe16aef3c$var$LEVELS.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "menu-button",
                        onClick: ()=>startLevel(l),
                        children: [
                            l.title,
                            " \u2014 ",
                            l.description
                        ]
                    }, l.id))
            })
        ]
    });
    const renderOperand = (which)=>{
        if (question.missing === which) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
            ref: inputRef,
            type: "text",
            inputMode: "numeric",
            pattern: "[0-9]*",
            className: `math-answer-input ${feedback || ''}`,
            value: userAnswer,
            onChange: (e)=>setUserAnswer(e.target.value.replace(/[^0-9]/g, '')),
            onKeyDown: handleKeyDown,
            disabled: feedback !== null,
            "aria-label": "N\xfamero em falta"
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "math-operand",
            children: which === 'a' ? question.a : question.b
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "N\xfamero em Falta"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "game-status",
                children: [
                    level.title,
                    " (",
                    level.description,
                    ") \xb7 Pontua\xe7\xe3o: ",
                    score.correct,
                    " / ",
                    score.total
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "math-equation",
                children: [
                    renderOperand('a'),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "math-operator",
                        children: question.op
                    }),
                    renderOperand('b'),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "math-operator",
                        children: "="
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "math-operand",
                        children: question.result
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `math-feedback ${feedback || ''}`,
                children: [
                    feedback === 'correct' && 'Correto!',
                    feedback === 'incorrect' && `Errado. ${question.a} ${question.op} ${question.b} = ${question.result}.`
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "game-buttons",
                children: [
                    feedback === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "new-game-button",
                        onClick: checkAnswer,
                        children: "Verificar"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        ref: nextButtonRef,
                        className: "new-game-button",
                        onClick: nextQuestion,
                        children: "Pr\xf3xima"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "new-game-button",
                        onClick: changeLevel,
                        children: "Mudar N\xedvel"
                    })
                ]
            })
        ]
    });
};
var $f087fb7fe16aef3c$export$2e2bcd8739ae039 = $f087fb7fe16aef3c$var$MissingOperand;


// Sections of the site. Each section has a list of items (games or activities).
// Adding a new topic (e.g. 2.º Ano, Geometria) is just a matter of adding
// another entry here and importing the corresponding component.
const $dad545c909cfec2d$var$SECTIONS = [
    {
        id: 'year1',
        title: "1.\xba Ano",
        description: "Atividades de matem\xe1tica para o 1.\xba ano de escolaridade.",
        items: [
            {
                id: 'additions-subtractions',
                title: "Adi\xe7\xf5es e Subtra\xe7\xf5es",
                component: (0, $6b5f0c1a730bb466$export$2e2bcd8739ae039)
            },
            {
                id: 'missing-operand',
                title: "N\xfamero em Falta",
                component: (0, $f087fb7fe16aef3c$export$2e2bcd8739ae039)
            }
        ]
    },
    {
        id: 'boardgames',
        title: 'Jogos de Tabuleiro',
        description: "Jogos cl\xe1ssicos de estrat\xe9gia para dois jogadores.",
        items: [
            {
                id: 'tictactoe',
                title: 'Jogo do Galo',
                component: (0, $861b3e0b5eea3893$export$2e2bcd8739ae039)
            },
            {
                id: 'trafficlights',
                title: "Sem\xe1foro",
                component: (0, $a55621b0d5c09ed5$export$2e2bcd8739ae039)
            },
            {
                id: 'catsanddogs',
                title: "Gatos e C\xe3es",
                component: (0, $ef100ffa4f625ae1$export$2e2bcd8739ae039)
            },
            {
                id: 'hex',
                title: 'Hex',
                component: (0, $3b6981476d25eccc$export$2e2bcd8739ae039)
            },
            {
                id: 'checkers',
                title: 'Damas',
                component: (0, $2b62029c4c661a69$export$2e2bcd8739ae039)
            },
            {
                id: 'ninemensmorris',
                title: 'Moinho',
                component: (0, $67d74e7c9903d973$export$2e2bcd8739ae039)
            },
            {
                id: 'foxandgeese',
                title: 'Fox and Geese',
                component: (0, $8e3009e73d7d2f4c$export$2e2bcd8739ae039)
            },
            {
                id: 'domineering',
                title: "Domin\xf3rio",
                component: (0, $a761368a2ac1906f$export$2e2bcd8739ae039)
            },
            {
                id: 'atarigo',
                title: 'Atari Go',
                component: (0, $00886599104d87f2$export$2e2bcd8739ae039)
            },
            {
                id: 'amazons',
                title: 'Amazons',
                component: (0, $61840e079ced8044$export$2e2bcd8739ae039)
            },
            {
                id: 'breakthrough',
                title: 'Breakthrough',
                component: (0, $b2b53853da6eaef8$export$2e2bcd8739ae039)
            },
            {
                id: 'aboyne',
                title: 'Aboyne',
                component: (0, $058a925513e726f9$export$2e2bcd8739ae039)
            }
        ]
    }
];
const $dad545c909cfec2d$var$App = ()=>{
    const [sectionId, setSectionId] = (0, $acw62.useState)(null);
    const [itemId, setItemId] = (0, $acw62.useState)(null);
    // Top-level menu: pick a section (e.g. 1.º Ano, Jogos de Tabuleiro).
    if (!sectionId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: "Desafio Aceite"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: "Matem\xe1tica"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "game-menu",
                children: $dad545c909cfec2d$var$SECTIONS.map((section)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "menu-button",
                        onClick: ()=>setSectionId(section.id),
                        children: section.title
                    }, section.id))
            })
        ]
    });
    const section = $dad545c909cfec2d$var$SECTIONS.find((s)=>s.id === sectionId);
    // Section menu: pick an item inside the chosen section.
    if (!itemId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "game-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "back-button",
                onClick: ()=>setSectionId(null),
                children: "\u2190 Voltar"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "game-title",
                children: section.title
            }),
            section.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "config-subtitle",
                children: section.description
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "game-menu",
                children: section.items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "menu-button",
                        onClick: ()=>setItemId(item.id),
                        children: item.title
                    }, item.id))
            })
        ]
    });
    const item = section.items.find((i)=>i.id === itemId);
    const ItemComponent = item.component;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "back-button",
                onClick: ()=>setItemId(null),
                children: "\u2190 Voltar"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ItemComponent, {})
        ]
    });
};
const $dad545c909cfec2d$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root'));
$dad545c909cfec2d$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dad545c909cfec2d$var$App, {}));


//# sourceMappingURL=repo.326c9b57.js.map
